import { useCallback, useEffect, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import decimal from 'decimal.js';
import { SelectSessionButton } from './KeysAndSigningUI';
import { TextArea2, TextLine3 } from './UtilComponents'
import { ConfirmationPopupContent } from './UtilComponents';
import { getInitialIssuanceState, useGlobalStateSelector, words } from './globalState'
import { sortByTokenName } from './TokenFilter';
import {
  buildMonapartyTransactions,
  getAssetNames,
  getMonacardInfoAfterAll,
} from './blockchain';
import {
  addSendsToTheCartMona,
  addTokensToTheCartMonaparty,
  buildMonaTransactions,
  fetchRecentTxids,
  firstTransactionRitual,
  handleClickAdditionalIssuance,
  handleClickCommitMonaTransaction,
  handleClickEditAssetInfo,
  handleClickEditCreatorInformation,
  handleClickIssueAsset,
  handleClickLockIssuance,
  handleClickTransferOwnership,
  quantityForDisplay,
} from './walletCore';
import { getValidKeyPairs, handleClickMpurse, handleClickNfc } from './keysAndSigning';
import {
  cleanUpObject,
  decimalAdjust,
  devLog,
  handleClickGoTop,
} from './utils'
import { handleClickScanQr } from './utils';
import iconQr from './image/qr_code_2_FILL0_wght400_GRAD0_opsz24.svg';
import iconAddress from './image/slab_serif_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconCard from './image/book_FILL0_wght400_GRAD0_opsz48.svg';
import iconCopy from './image/content_copy_FILL0_wght400_GRAD0_opsz48.svg';
import iconCotto from './image/cotto.png';
import iconDetail from './image/more_horiz_FILL0_wght400_GRAD0_opsz48.svg';
import iconEdit from './image/edit_FILL0_wght400_GRAD0_opsz48.svg';
import iconKeyCard from './image/playing_cards_FILL0_wght400_GRAD0_opsz24.svg';
import iconLock from './image/lock_FILL0_wght400_GRAD0_opsz48.svg';
import iconSend from './image/send_24dp_FILL0_wght400_GRAD0_opsz24.svg';
import iconSign from './image/history_edu_FILL0_wght400_GRAD0_opsz48.svg';
import iconSwords from './image/swords_24dp_FILL0_wght400_GRAD0_opsz24.svg';
import imageNotAMonacard from './image/notAMonacard.png';
import logoMonacotto from './image/logoMonacotto.png';

// BALANCE MONA
function BalanceMona(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));

  let addressMain;
  let balanceMona = 0;

  if (state.active.addressMain !== undefined && state.active.addressMain !== null) {
    addressMain = state.active.addressMain;

    if (state.balance.mona[addressMain] !== undefined) {
      balanceMona = new decimal(state.balance.mona[addressMain]).div(100000000).toNumber();
    }
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn justifyContentCenter alignItemsCenter monaBox marginTop1">
        <div className="marginTopBottom1">
          MONA
        </div>
        <div className="marginTopBottom1">
          { balanceMona }
        </div>
        <button className='button1 marginTopBottom1'
          onClick={ () => {
            const popup = { type: 'sendMonaPopoup' };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
          }}
        >
          {/* words.send[state.language] */}
          <img className='size2x2' src={iconSend} alt='' />
        </button>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn justifyContentCenter alignItemsCenter monaBox marginTop1 ">
        <div className="marginTopBottom1">
          MONA
        </div>
        <div className="marginTopBottom1">
          { balanceMona }
        </div>
        <button className='button1 marginTopBottom1'
          onClick={ () => {
            const popup = { type: 'sendMonaPopoup' };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
          }}
        >
          {/* words.send[state.language] */}
          <img className='size2x2' src={iconSend} alt='' />
        </button>
      </div>
    </div>
  );
}

// BALANCE XMP
function BalanceXmp(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));

  let addressMain;
  let balanceXmp = 0;

  if (state.active.addressMain !== undefined && state.active.addressMain !== null) {
    addressMain = state.active.addressMain;

    if (state.balance.monaparty[addressMain]?.XMP !== undefined) {
      balanceXmp = new decimal(state.balance.monaparty[addressMain].XMP.quantity).div(100000000).toNumber();
    }
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn justifyContentCenter alignItemsCenter monaBox marginTop1">
        <div className="marginTopBottom1">
          XMP
        </div>
        <div className="marginTopBottom1">
          { balanceXmp }
        </div>
        <button className='button1 marginTopBottom1'
          onClick={ () => {
            const popup = { type: 'sendXmpPopoup' };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
          }}
        >
          {/* words.send[state.language] */}
          <img className='size2x2' src={iconSend} alt='' />
        </button>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn justifyContentCenter alignItemsCenter monaBox marginTop1 ">
        <div className="marginTopBottom1">
          XMP
        </div>
        <div className="marginTopBottom1">
          { balanceXmp }
        </div>
        <button className='button1 marginTopBottom1'
          onClick={ () => {
            const popup = { type: 'sendXmpPopoup' };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
          }}
        >
          {/* words.send[state.language] */}
          <img className='size2x2' src={iconSend} alt='' />
        </button>
      </div>
    </div>
  );
}

// BALANCE MONAPARTY
function BalanceMonaparty(props) {
  const state = useGlobalStateSelector( ({ state }) => state );

  let addressMain;

  if (state.active.addressMain !== undefined && state.active.addressMain !== null) {
    addressMain = state.active.addressMain;
  }
  else {
    return null;
  }

  let balanceMonaparty;

  if (state.balance.monaparty[addressMain] !== undefined) {
    balanceMonaparty = state.balance.monaparty[state.active.addressMain];
  }
  else {
    return null;
  }

  // オウンドアセット

  let assetOwned =
   (state.ownedAssets[state.active.addressMain] || [])
  .filter( item => !Object.keys(state.config.clientParameters.asssetsForbidden).includes(item.asset) )
  .map( item => {
    if (balanceMonaparty[item.asset] !== undefined) {
      const itemWithBalance = balanceMonaparty[item.asset];
      itemWithBalance.owner = item.owner;
      return itemWithBalance;
    }
    else {
      const itemWithBalance = {
        asset: item.asset,
        // asset_longname: item.asset_longname,
        // owner: item.owner,
        quantity: 0,
      };

      return itemWithBalance;
    }
  });

  assetOwned = sortByTokenName(state, assetOwned);

  // バランスドアセット

  let assetsBalanced =
   Object.values(state.balance.monaparty[state.active.addressMain])
  .filter( item => item.quantity > 0 )
  .filter( item => item.asset !== 'XMP' )
  .filter( item => !Object.keys(state.config.clientParameters.asssetsForbidden).includes(item.asset) )
  .filter( item => !assetOwned.some( owned => owned.asset === item.asset ) );

  assetsBalanced = sortByTokenName(state, assetsBalanced);

  let items = assetOwned.concat(assetsBalanced);

  // // トークン名でソート

  // items = assetsBalanced.sort( (a, b) => {
  //   let aComp;
  //   let bComp;

  //   if (state.assetInfo[a.asset]?.asset_longname !== undefined && state.assetInfo[a.asset]?.asset_longname !== null) {
  //     aComp = state.assetInfo[a.asset].asset_longname; 
  //   }
  //   else {
  //     aComp = a.asset; 
  //   }

  //   if (state.assetInfo[b.asset]?.asset_longname !== undefined && state.assetInfo[b.asset]?.asset_longname !== null) {
  //     bComp = state.assetInfo[b.asset].asset_longname; 
  //   }
  //   else {
  //     bComp = b.asset; 
  //   }

  //   if (aComp < bComp) {
  //     return -1;
  //   }
  //   else if (aComp > bComp) {
  //     return 1;
  //   }
  //   else {
  //     return 0;
  //   }
  // });
  // // .sort( (a, b) => a.asset - b.asset )

  // 本命フィルタ
  items = state.tokenFilter.conditions.reduce( (acc, cur) =>
    acc.filter( item => {
      let attributesUnified = {};

      if (state.assetInfo[item.asset]?.asset_longname !== undefined && state.assetInfo[item.asset].asset_longname !== null) {
        attributesUnified.assetCommon = state.assetInfo[item.asset].asset_longname;
      }
      else {
        attributesUnified.assetCommon = item.asset;
      }

      if (state.assetInfo[item.asset] !== undefined) {
        attributesUnified.addressOwners = state.assetInfo[item.asset].owner;
        attributesUnified.lockStatus = state.assetInfo[item.asset].locked === true ? 'locked' : 'unlocked';
      }

      if (state.assetInfo[item.asset]?.description !== undefined && state.assetInfo[item.asset]?.description !== null && state.assetInfo[item.asset]?.description !== '' ) {
        try {
          const description = JSON.parse(state.assetInfo[item.asset].description);
          attributesUnified.monacardName = description.monacard.name;
          attributesUnified.monacardIssuerNames = description.monacard.owner;
          attributesUnified.monacardDescription = description.monacard.desc;
          attributesUnified.monacardTags = description.monacard.tag.split(',');
        }
        catch (err) {
          // モナカードのdescriptionじゃない。
        }
      }

      if (state.registeredCard[item.asset] !== undefined) {
        attributesUnified.monadom = 'registered';
      }
      else {
        attributesUnified.monadom = 'unregistered';
      }

      if (Object.keys(cur).some( key => cur[key].length >= 1 )) {
        return Object.keys(cur).some( key => {
          if (key === 'monacardName' || key === 'monacardDescription' || key === 'assetCommon') {
            return cur[key].some( condition => {
              return new RegExp(condition).test(attributesUnified[key]);
            });
          }
          else if (Array.isArray(attributesUnified[key])) {
            return attributesUnified[key].some( attribute => cur[key].includes(attribute) );
          }
          else { // scalar
            return cur[key].includes(attributesUnified[key]);
          }
        });
      }
      else {
        return true;
      }
    })
    , items
  );

  // コンポーネントにマップ

  items = items.map ( item => <Item item={item} styleName='small' quantity={true} arrows={false} />);

  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className="flexRow justifyContentSpaceAround">
            { items }
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        <div className="flexRow justifyContentSpaceAround">
            { items }
        </div>
      </div>
    </div>
  );
}

// ITEM
function Item(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));

  // const popup = { type: 'itemDetail', body: props.item };
  const item = props.item;
  const quantity = props.quantity;
  // const arrows = props.arrows;
  const popupLayerNext = props.popupLayer !== undefined ? props.popupLayer + 1 : 0;

  let {
    cardName,
    // cardOwnerName,
    // cardDescription,
    // cid,
    cardImageUrl,
    cardImageUrlSP,
    isAMonacard,
  } = getMonacardInfoAfterAll(state, item, 'small');

  // スタイル

  let styleBox;
  let styleCard;
  let styleBoxSp;
  let styleCardSp;

  if (props.styleName === 'small') {
    styleBox = 'boxCardSmall';
    styleCard = 'cardImageSmall';
    styleBoxSp = 'boxCardSP padding0p5';
    styleCardSp = 'cardImageSmallSP';
  }
  else {
    styleBox = 'boxCard';
    styleCard = 'cardImage';
  }

  if (item.owner === state.active.addressMain) {
    styleBox += ' backgroundColorMonacottoAlmostWhite';
    styleBoxSp += ' backgroundColorMonacottoAlmostWhite';
  }

  // 画像

  let image;
  let imageSp;

  if (isAMonacard === false) {
    image = <img className={styleCard} src={imageNotAMonacard} alt='' />;
    imageSp = <img className={styleCardSp} src={imageNotAMonacard} alt='' />;
  }
  else {
    image = <img className={styleCard} src={cardImageUrl} alt='' />;
    imageSp = <img className={styleCardSp} src={cardImageUrlSP} alt='' />;
  }

  // SPにおいて、モナカードじゃなかった場合、モナカードではありません画像の上に、トークン名を表示する。

  let tokenNameOverImage;

  if (isAMonacard === false) {
    tokenNameOverImage =
    <div className={'absoluteZero z10 ' + styleCardSp + ' cardImageSmallSPHeight overflowHidden backgroundColorHalfWhite flexColumn justifyContentCenter'} >
      <div className='breakAll' >
        { cardName }
      </div>
    </div>
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <button className={styleBox} disabled={props.disabled ? true : false}
          onClick={ () => {
            const body = {
              item: item,
            };

            const popup = { type: 'itemDetail', body: body };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
          }}
        >
          <div className='flexColumn justifyContentFlexStart alignItemsCenter'>
            <div className='relative' >
              { image }
            </div>
            <div className='flexRow justifyContentFlexStart textCenter '>
              <CardName item={item} cardName={cardName} />
            </div>
            { quantity === true ? <Quantity item={item} /> : null }
          </div>
        </button>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        <button className={styleBoxSp} disabled={props.disabled ? true : false}
          onClick={ () => {
            const body = {
              item: item,
            };

            const popup = { type: 'itemDetail', body: body };
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
          }}
        >
          <div className='flexColumn justifyContentFlexStart alignItemsCenter'>
            <div className='relative' >
              { imageSp }
              { tokenNameOverImage }
            </div>
            { quantity === true ? <Quantity item={item} /> : null }
          </div>
        </button>
      </div>
    </div>
  );
}

// QUANTITY
function Quantity(props) {
  const { state } = useGlobalStateSelector(({ state }) => ({ state }));
  const item = props.item;
  // let addressMain;

  // if (state.active.addressMain !== undefined) {
  //   addressMain = state.active.addressMain;
  // }
  // else {
  //   return null;
  // }


  return (
    <div className='flexRow justifyContentCenter '>
      <div className=''>
        { quantityForDisplay(state, item) }
      </div>
    </div>
  );
}

// CARD NAME
function CardName(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const item = props.item;
  const cardName = props.cardName;

  let asset_longname;

  if (state.assetInfo[item.asset] !== undefined) {
    const assetInfo = state.assetInfo[item.asset];
    asset_longname = assetInfo.asset_longname;
  }

  let displayName;

  if (state.displayName === 'cardName') {
    if (cardName !== null) {
      displayName = cardName;
    }
    else if (asset_longname !== undefined && asset_longname !== null) {
      displayName = asset_longname;
    }
    else {
      displayName = item.asset;
    }
  }
  else if (state.displayName === 'asset_longname') {
    if (asset_longname !== undefined && asset_longname !== null) {
      displayName = asset_longname;
    }
    else {
      displayName = item.asset;
    }
  }
  else {
    displayName = item.asset;
  }


  return (
    <div className='flexColumn alignItemsCenter '>
      <div className='textCenter '>
        { displayName }
      </div>
    </div>
  );
}

// ITEM DETAIL
function ItemDetail(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const popupLayer = props.popupLayer;
  const item = state.popup[popupLayer].body.item;
  const assetCommon = (state.assetInfo[item.asset] === undefined || state.assetInfo[item.asset].asset_longname === null) ? item.asset : state.assetInfo[item.asset].asset_longname;
  const information = state.registeredCard[item.asset];

  let {
    cardName,
    cardOwnerName,
    cardDescription,
    cardTag,
    cid,
    cardImageUrl,
    cardImageUrlSP,
    isAMonacard,
  } = getMonacardInfoAfterAll(state, item, 'large');

  // useEffect( () => {
  //   const func = async () => {
  //     // アセット情報取得
  //     getAssetInfo(state, dispatch, [item.asset]);
  //   };

  //   func();
  // }, []);

  // 発行数

  let supply;

  if (state.assetInfo[item.asset] !== undefined) {
    if (state.assetInfo[item.asset].divisible === true) {
      supply = new decimal(state.assetInfo[item.asset].supply).div(100000000).toNumber();
    }
    else {
      supply = state.assetInfo[item.asset].supply;
    }
  }
  else {
    supply = null;
  }

  // ロック画像

  let lockedImage;

  if (state.assetInfo[item.asset] !== undefined && state.assetInfo[item.asset].locked) {
    lockedImage = <img className='size1p7x1p7' src={iconLock} alt='' />;
  }
  else {
    lockedImage = null;
  }

  // ディスペンサー可否

  let vendable;

  if (state.assetInfo[item.asset] !== undefined) {
    if (state.assetInfo[item.asset].vendable) {
      vendable =
        <div className='borderMonacotto padding0p3 marginTopBottom0p5'>
          {words.vendable[state.language]}
        </div>;
    }
    else {
      vendable =
        <div className='borderMonacotto padding0p3 marginTopBottom0p5'>
          {words.notVendable[state.language]}
        </div>;
    }
  }
  else {
    vendable = null;
  }

  // DEX可否

  let listed;

  if (state.assetInfo[item.asset] !== undefined) {
    if (state.assetInfo[item.asset].listed) {
      listed =
        <div className='borderMonacotto padding0p3 marginTopBottom0p5 marginLeft0p5'>
          {words.listed[state.language]}
        </div>;
    }
    else {
      listed =
        <div className='borderMonacotto padding0p3 marginTopBottom0p5 marginLeft0p5'>
          {words.notListed[state.language]}
        </div>;
    }
  }
  else {
    listed = null;
  }

  /*
  let reassignable;

  if (state.assetInfo[item.asset] !== undefined && state.assetInfo[item.asset].reassignable) {
    reassignable =
      <div className='borderMonacotto'>
        reassignable
      </div>;
  }
  else {
    reassignable = null;
  }
  */

  // // let cardName;
  // // let cardDescription;

  // // if (state.assetInfo[item.asset] !== undefined) {
  // //   try {
  // //     const description = JSON.parse(state.assetInfo[item.asset].description);
  // //     cardName = description.monacard.name;
  // //     cardDescription = description.monacard.desc;
  // //   }
  // //   catch (err) {
  // //     if (state.monacard[item.asset] !== undefined) {
  // //       cardName = state.monacard[item.asset].card_name;
  // //       cardDescription = state.monacard[item.asset].add_description;
  // //     }
  // //     else {
  // //       cardName = null;
  // //       cardDescription = null;
  // //     }
  // //   }
  // // }
  // // else {
  // //   cardName = null;
  // //   cardDescription = null;
  // // }

  // 保有数

  let balance;
  let balanceNum = 0;

  for (const address of Object.keys(state.session)) {
    if (state.session[address].expirationOfSession >= Date.now()) {
      balanceNum += state.balance.monaparty[address]?.[item.asset]?.quantity || 0;
    }
  }

  if (Object.keys(state.session).length > 0) {
    balance = <div className='flexRow alignItemsFlexEnd marginRight1 '>
      <div className=''>
        {words.numberOfHoldings[state.language]}
      </div>
      <div className='font1p5 marginSide0p5'>
        { quantityForDisplay(state, item, balanceNum) }
      </div>
    </div>
  }
  else {
    balance = null;
  }

  // オーナー
  let ownerBlock;
  let ownerBlockSp;

  if (state.assetInfo[item.asset] !== undefined) {
    const owner = state.assetInfo[item.asset].owner;

    if (cardOwnerName !== undefined) {
      ownerBlock =
      <div className='flexColumn alignItemsFlexStart paddingLeft1'>
        <div >
          {cardOwnerName}
        </div >
        <div >
          {owner}
        </div >
      </div>;

      ownerBlockSp =
      <div className='flexColumn alignItemsFlexStart paddingLeft1'>
        <div >
          {cardOwnerName}
        </div >
        <div className='breakAll' >
          {owner}
        </div >
      </div>;
    }
    else {
      ownerBlock =
      <div className='flexColumn alignItemsFlexStart paddingLeft1'>
        <div >
          {owner}
        </div >
      </div>;

      ownerBlockSp =
      <div className='flexColumn alignItemsFlexStart paddingLeft1'>
        <div className='breakAll' >
          {owner}
        </div >
      </div>;
    }
  }
  else {
    ownerBlock = null;
    ownerBlockSp = null;
  }

  // 送信ボタン

  const sendButton =
  <button className='button1' tabindex='0'
    onClick={ () => {
      dispatch({ type: 'setStateMultiLayers', keys: ['sendToken', 'asset'], value: item.asset });
      // const body = <SendToken asset={item.asset} popupLayer={popupLayer + 1} />;
      const body = {
        asset: item.asset,
      };
      const popup = { type: 'sendTokenPopup', body: body };
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
    }}
  >
    <img className='size2x2' src={iconSend} alt='' />
  </button>;

  // アセット情報編集ボタン

  let editAssetInfoButton;

  if (true) {
    editAssetInfoButton =
    <button className='button1' tabindex='0'
      onClick={ () => {
        const assetInfo = state.assetInfo[item.asset];

        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'addressOwner'], value: assetInfo.owner });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'asset'], value: assetInfo.asset });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'assetCommon'], value: assetInfo.asset_longname !== null ? assetInfo.asset_longname : item.asset });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'supply'], value: assetInfo.supply });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'monacardName'], value: isAMonacard ? cardName : null});
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'monacardIssuerName'], value: cardOwnerName });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'monacardDescription'], value: isAMonacard ? cardDescription : null });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'monacardTag'], value: cardTag });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'cid'], value: cid });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'description'], value: assetInfo.description });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'lock'], value: assetInfo.locked });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'divisible'], value: assetInfo.divisible });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'listed'], value: assetInfo.listed });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'vendable'], value: assetInfo.vendable });
        dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'reassignable'], value: assetInfo.reassignable });

        const body = {
          asset: item.asset,
          monacardName: cardName,
          monacardOwnerName: cardOwnerName,
          monacardDescription: cardDescription,
          monacardTag: cardTag,
          cid,
          cardImageUrl,
          cardImageUrlSP,
          isAMonacard,
          description: state.assetInfo[item.asset].description,
          locked: state.assetInfo[item.asset].locked,
          divisible: state.assetInfo[item.asset].divisible,
          listed: state.assetInfo[item.asset].listed,
          vendable: state.assetInfo[item.asset].vendable,
          reassignable: state.assetInfo[item.asset].reassignable,
        };
        const popup = { type: 'editAssetInfoPopup', body: body };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
      }}
    >
      <img className='size2x2' src={iconEdit} alt='' />
    </button>;
  }

  // 画像

  let image;
  let imageSp;

  if (isAMonacard === false) {
    image = <img className='cardImageLarge' src={imageNotAMonacard} alt='' />;
    imageSp = <img className='cardImageFullWidth' src={imageNotAMonacard} alt='' />;
  }
  else {
    image = <img className='cardImageLarge' src={cardImageUrl} alt='' />
    imageSp = <img className='cardImageFullWidth' src={cardImageUrlSP} alt='' />
  }

  // モナダム情報

  let monadomInfoLite;
  let monadomInfoButton;

  if (information !== undefined) {
    // エディション(レプリカ)
    let edition;

    if (information.edition === 'replica') {
      edition =
      <div className='marginSide0p5'>
        【OFFICIAL REPLICA】
      </div>;
    }

    if (information.category === 'magic') {

      monadomInfoLite =
      <div className='flexColumn alignItemsCenter widthMax ' >
        <div className='flexColumn alignItemsFlexStart width90PC padding1 backgroundImageKOM borderRadius0p5 ' >
          <div className='flexRow justifyContentSpaceBetween alignItemsFlexStart widthMax marginTopBottom1'>
            <div className=''>
              { words.magic[state.language] }
            </div>
            <div className='flexRow alignItemsCenter'>
              { edition }
            </div>
          </div>
          <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
            <div className=''>
              { words.name[state.language] }
            </div>
            <div className=''>
              { information.name }
            </div>
            <div className='preWrap marginTop1'>
              { information.flavorText }
            </div>
          </div>
        </div>
      </div>
    }
    else { // monster
      monadomInfoLite =
      <div className='flexColumn alignItemsCenter widthMax ' >
        <div className='flexColumn alignItemsFlexStart width90PC padding1 backgroundImageKOM borderRadius0p5 ' >
          <div className='flexRow justifyContentSpaceBetween alignItemsFlexStart widthMax marginTopBottom1'>
            <div className=''>
              { words.knight[state.language] }
            </div>
            <div className='flexRow alignItemsCenter'>
              { edition }
            </div>
          </div>
          <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
            <div className=''>
              { words.name[state.language] }
            </div>
            <div className=''>
              { information.name }
            </div>
          </div>
          <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
            <div className=''>
              { words.profile[state.language] }
            </div>
            <div className=''>
              { information.feature }
            </div>
          </div>
        </div>
      </div>
    }

    // monadom detail button

    monadomInfoButton =
    <button className='button1' tabindex='0'
      onClick={ () => {
        const card = {
          ...item,
          cardImageUrl,
          cardImageUrlSP,
          isAMonacard,
        };

        const popup = {
          type: 'monadomInfo',
          body: {
            card,
          },
        };

        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
      }}
    >
      <img className='size2x2' src={iconSwords} alt='' />
    </button>;
  }


  return (
    <div className=''>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className='flexRow justifyContentCenter'>
          {/* image */}
          <div className='margin2'>
            { image }
          </div>
          {/* description */}
          <div className='flexColumn cardImageLarge' >
            <div className='margin2'>
              <div className='flexRow justifyContentFlexStart alignItemsCenter' >
                <div className='flexColumn' >
                  <div className='marginBottom0p5 font1p5'>
                    {assetCommon}
                  </div>
                </div>
              </div>
              <div className='flexRow alignItemsFlexEnd marginBottom0p5 '>
                { balance }
                <div className=''>
                  {words.amountIssued[state.language]}
                </div>
                <div className='font1p5 marginSide0p5'>
                  {`${supply}`}
                </div>
                { lockedImage }
              </div>
              <div className='flexRow alignItemsFlexEnd marginBottom0p5 '>
                { vendable }
                { listed }
              </div>
              <div className='flexColumn marginBottom0p5'>
                <div>
                  {words.owner[state.language]}
                </div>
                { ownerBlock }
              </div>
            </div>
            <div className='flexColumn margin2'>
              <div className='widthMax25 font1p5 marginBottom0p5'>
                { cardName }
              </div>
              <div className='widthMax25'>
                { cardDescription }
              </div>
            </div>
            <div className='flexRow margin2'>
              {/* item detail more */}
              <button className='button1' tabindex='0'
                onClick={ () => {
                  const popup = { type: 'itemDetailMore', body: item };
                  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
                }}
              >
                <img className='size2x2' src={iconDetail} alt='' />
              </button>
              { monadomInfoButton }
              {/* Monacard */}
              <button className='button1' tabindex='0'
                onClick={ () => window.open(`https://card.mona.jp/explorer/card_detail?asset=${item.asset}`) }
              >
                <img className='size2x2' src={iconCard} alt='' />
              </button>
              { editAssetInfoButton }
              { sendButton }
            </div>
            { monadomInfoLite }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn alignItemsCenter visibleSmallOrLess ">
        {/* image */}
        <div className='marginTopBottom1'>
          { imageSp }
        </div>
        <div className='flexColumn alignItemsCenter marginTopBottom1'>
          <div className='width96vw'>
            <div className='flexRow justifyContentFlexStart alignItemsCenter' >
              <div className='flexColumn' >
                <div className='marginBottom0p5 font1p5'>
                  {assetCommon}
                </div>
              </div>
            </div>
            <div className='flexRow alignItemsFlexEnd marginBottom0p5 '>
              { balance }
              <div className=''>
                {words.amountIssued[state.language]}
              </div>
              <div className='font1p5 marginSide0p5'>
                {`${supply}`}
              </div>
              { lockedImage }
            </div>
            <div className='flexRow alignItemsFlexEnd marginBottom0p5 '>
              { vendable }
              { listed }
            </div>
            {/* owner */}
            <div className='flexColumn marginBottom0p5 '>
              <div>
                {words.owner[state.language]}
              </div>
              { ownerBlockSp }
            </div>
            <div className='flexColumn marginTopBottom1'>
              {/* card name */}
              <div className='widthMax25 font1p5 marginBottom0p5'>
                {/* state.monacard[item.asset] !== undefined ? state.monacard[item.asset].card_name : null */}
                { cardName }
              </div>
              {/* description */}
              <div className='widthMax25'>
                {/* state.monacard[item.asset] !== undefined ? state.monacard[item.asset].add_description : null */}
                { cardDescription }
              </div>
            </div>
            <div className='flexRow marginTopBottom1'>
              {/* item detail more */}
              <button className='button1' tabindex='0'
                onClick={ () => {
                  const popup = { type: 'itemDetailMore', body: item };
                  dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
                }}
              >
                <img className='size2x2' src={iconDetail} alt='' />
              </button>
              { monadomInfoButton }
              {/* Monacard */}
              <button className='button1' tabindex='0'
                onClick={ () => window.open(`https://card.mona.jp/explorer/card_detail?asset=${item.asset}`) }
              >
                <img className='size2x2' src={iconCard} alt='' />
              </button>
              { editAssetInfoButton }
              { sendButton }
            </div>
            { monadomInfoLite }
          </div>
        </div>
      </div>
    </div>
  );
}

// MONADOM INFO
function MonadomInfo(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const popupLayer = props.popupLayer;
  const card = state.popup[popupLayer].body.card;

  // 画像

  let image;
  let imageSp;

  if (card.isAMonacard === false) {
    image = <img className='cardImageLarge marginSide1' src={imageNotAMonacard} alt='' />;
    imageSp = <img className='cardImageFullWidth' src={imageNotAMonacard} alt='' />;
  }
  else {
    image = <img className='cardImageLarge marginSide1' src={card.cardImageUrl} alt='' />;
    imageSp = <img className='cardImageFullWidth' src={card.cardImageUrlSP} alt='' />;
  }

  // クリエイター情報編集

  const popup = { type: 'creatorInformation', body: card };

  const editButton =
  <button className='button1'
    onClick={ () => {
      const monacottoAddressMain = state.registeredCard[card.asset].monacottoLink?.url?.match(/mainaddress=(\w+)$/)[1];

      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'creater'], value: state.registeredCard[card.asset].creater }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrText'], value: state.registeredCard[card.asset].createrText }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'monacottoAddressMain'], value: monacottoAddressMain }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 0, 'title'], value: state.registeredCard[card.asset]?.createrLink?.[0]?.title }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 0, 'url'], value: state.registeredCard[card.asset]?.createrLink?.[0]?.url }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 1, 'title'], value: state.registeredCard[card.asset]?.createrLink?.[1]?.title }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 1, 'url'], value: state.registeredCard[card.asset]?.createrLink?.[1]?.url }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 2, 'title'], value: state.registeredCard[card.asset]?.createrLink?.[2]?.title }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['creatorInformation', 'createrLink', 2, 'url'], value: state.registeredCard[card.asset]?.createrLink?.[2]?.url }); 
      dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.popupLayer + 1], value: popup }); 
    }}
  >
    <img className='size2x2' src={iconEdit} alt='' />
  </button>;


  return (
    <div className=''>
      {/* PC */}
      <div className='visibleMiddleOrMore flexRow justifyContentCenter'>
        <div className=''>
          { image }
        </div>
        <div className='flexColumn alignItemsFlexStart cardImageLarge marginSide1'>
          <div className='flexColumn alignItemsFlexStart widthMax '>
            <CardSpec card={card} />
          </div>
          <div className='flexColumn alignItemsFlexStart widthMax borderKOMFatBorder padding1 marginTop0p5'>
            <div className='flexRow alignItemsFlexEnd marginBottom0p5'>
              <div className='marginRight1'>
                { words.creater[state.language] }
              </div>
              <div className='font1p5'>
                { state.registeredCard[card.asset].creater }
              </div>
            </div>
            <textarea className='widthMax height15 backgroundColorTransparent borderKOM preWrap padding0p5 marginTopBottom1'
              value={ state.registeredCard[card.asset].createrText }
            />
            <div className='flexRow justifyContentFlexStart '>
              <MonacottoLink asset={card.asset}  />
              <CreaterLink asset={card.asset} index={0} />
              <CreaterLink asset={card.asset} index={1} />
              <CreaterLink asset={card.asset} index={2} />
            </div>
            <div className='flexRow justifyContentFlexEnd widthMax '>
              { editButton }
            </div>
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsCenter ">
        <div className=''>
          { imageSp }
        </div>
        <div className='flexColumn alignItemsFlexStart width96vw '>
          <div className='flexColumn alignItemsFlexStart widthMax '>
            <CardSpec card={card} />
          </div>
          <div className='flexColumn alignItemsFlexStart widthMax borderKOMFatBorder padding1 marginTop0p5'>
            <div className='flexRow alignItemsFlexEnd marginBottom0p5'>
              <div className='marginRight1'>
                { words.creater[state.language] }
              </div>
              <div className='font1p5'>
                { state.registeredCard[card.asset].creater }
              </div>
            </div>
            <textarea className='widthMax height15 backgroundColorTransparent borderKOM preWrap padding0p5 marginTopBottom1'
              value={ state.registeredCard[card.asset].createrText }
            />
            <div className='flexRow justifyContentFlexStart '>
              <MonacottoLink asset={card.asset}  />
              <CreaterLink asset={card.asset} index={0} />
              <CreaterLink asset={card.asset} index={1} />
              <CreaterLink asset={card.asset} index={2} />
            </div>
            <div className='flexRow justifyContentFlexEnd widthMax '>
              { editButton }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
// CARD SPEC
function CardSpec(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const card = props.card;
  const information = state.registeredCard[card.asset];

  // エディション(レプリカ)
  let edition;

  if (information.edition === 'replica') {
    edition =
    <div className='marginSide0p5'>
      【OFFICIAL REPLICA】
    </div>;
  }

  // カードスペック

  let spec;

  if (information.category === 'magic') {

    // タイプ
    let typeText = '';

    if (information.preEffects !== undefined) {
      typeText = information.preEffects.reduce( (acc, cur) => {
        if (cur.type !== undefined && cur.type !== null && cur.type !== '') {
          return acc + words[cur.type][state.language] + ' ';
        }
        else {
          return acc;
        }
      },
      '');
    }

    if (typeText === '') {
      typeText = words.nothing[state.language];
    }

    // コスト
    let costText = '';

    if (information.costs !== undefined) {
      for (const cost of information.costs) {
        if (cost.type === 'discardCards') {
          if (cost.comparison === 'equal') {
            costText += words.discardCards01[state.language] + cost.amount + words.discardCards02[state.language];
          }
        }
      }
    }

    if (costText === '') {
      costText = words.nothing[state.language];
    }

    // 排他
    let exclusionText = '';

    if (information.exclusions !== undefined) {
      for (const exclusion of information.exclusions) {
        if (exclusion.type === 'excludeOpponent') {
          exclusionText += exclusion.typesToExclude.reduce( (acc, cur) => acc + words[cur][state.language] + ' ', '');
        }
      }
    }

    if (exclusionText === '') {
      exclusionText = words.nothing[state.language];
    }

    spec =
    <div className='flexColumn alignItemsFlexStart widthMax padding0p5' >
      <div className='flexRow justifyContentSpaceBetween alignItemsFlexStart widthMax marginTopBottom1'>
        <div className=''>
          { words.magic[state.language] }
        </div>
        <div className='flexRow alignItemsCenter'>
          { edition }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.name[state.language] }
        </div>
        <div className=''>
          { information.name }
        </div>
        <div className='preWrap marginTop1'>
          { information.flavorText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.type[state.language] }
        </div>
        <div className='preWrap'>
          { typeText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.effect[state.language] }
        </div>
        <div className='preWrap'>
          { information.effectText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.cost[state.language] }
        </div>
        <div className='preWrap'>
          { costText }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.exclusion[state.language] }
        </div>
        <div className='preWrap'>
          { exclusionText }
        </div>
      </div>
      <div className='flexRow alignItemsCenter borderMonacotto marginTop1' >
        <div className='textCenter width2p4 height1p2' >
          { '0' }
        </div>
        {
          information.maginaThresholds.map( threshold =>
            <div className='textCenter width2p4 height1p2' >
              { threshold.face !== undefined ? threshold.face : threshold.upperBound }
            </div>
          )
        }
      </div>
    </div>
  }
  else { // monster
    spec =
    <div className='flexColumn alignItemsFlexStart widthMax padding0p5' >
      <div className='flexRow justifyContentSpaceBetween alignItemsFlexStart widthMax marginTopBottom1'>
        <div className=''>
          { words.knight[state.language] }
        </div>
        <div className='flexRow alignItemsCenter'>
          { edition }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.name[state.language] }
        </div>
        <div className=''>
          { information.name }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTopBottom1'>
        <div className=''>
          { words.profile[state.language] }
        </div>
        <div className=''>
          { information.feature }
        </div>
      </div>
    </div>
  }

  return spec;
}

// MONACOTTO LINK
function MonacottoLink(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const asset = props.asset;

  if (state.registeredCard[asset].monacottoLink?.url === undefined) {
    return null;
  }

  return (
    <div className='flexRow alignItemsCenter marginBottom0p5 marginSide0p5'>
      <button className='buttonMainColor widthMin10 height2p2 paddingSide1 flexRow justifyContentCenter alignItemsCenter ' tabindex='0' 
        onClick={ () => {
          window.open( state.registeredCard[asset].monacottoLink.url );
        }}
      >
        <img className='heightMax' src={logoMonacotto} alt='' />
        <img className='heightMax' src={iconCotto} alt='' />
      </button>
      <button className='button1' tabindex='0' 
        onClick={ () => {
          navigator.clipboard.writeText( state.registeredCard[asset].monacottoLink.url )
          .then()
          .catch();
        }}
      >
        <img className='size2x2' src={iconCopy} alt='' />
      </button>
    </div>
  );
}

// CREATER LINK
function CreaterLink(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const asset = props.asset;
  const index = props.index;

  if (state.registeredCard[asset].createrLink?.[index] === undefined) {
    return null;
  }

  return (
    <div className='flexRow alignItemsCenter marginBottom0p5 marginSide0p5'>
      <button className='buttonMainColor widthMin10 height2p2 paddingSide1 textCenter flexRow justifyContentCenter alignItemsCenter ' tabindex='0' 
        onClick={ () => {
          window.open( state.registeredCard[asset].createrLink[index].url );
        }}
      >
        { state.registeredCard[asset].createrLink[index].title }
      </button>
      <button className='button1' tabindex='0' 
        onClick={ () => {
          navigator.clipboard.writeText( state.registeredCard[asset].createrLink[index].url )
          .then()
          .catch();
        }}
      >
        <img className='size2x2' src={iconCopy} alt='' />
      </button>
    </div>
  );
}

// CREATOR INFORMATION
function CreatorInformation(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const item = state.popup[props.popupLayer].body;

  // 登録ボタン

  let registerButton;

  if (state.walletType === 'mpurse') {
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ () => {
          handleClickEditCreatorInformation(state, dispatch, item.asset);
        }}
      >
        <div>
          {words.signByOwnerAddressToRegister[state.language]}
        </div>
        <img className='size2x2' src={iconSign} alt=''/>
      </button>
    </div>
  }
  else if (state.walletType === 'nfc') {
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ () => {
          const callback = (keyPairs) => handleClickEditCreatorInformation(state, dispatch, item.asset, { keyPairs });
          handleClickNfc(state, dispatch, callback);
        }}
      >
        <div>
          {words.signByOwnerAddressToRegister[state.language]}
        </div>
        <div>
          <img className='size2x2' src={iconKeyCard} alt=''/>
        </div>
      </button>
    </div>
  }
  else { // qr
    registerButton =
    <div className='flexRow justifyContentCenter widthMax marginTop1'>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ () => {
          const callback = (keyPairs) => handleClickEditCreatorInformation(state, dispatch, item.asset, { keyPairs });
          handleClickScanQr(state, dispatch, callback, { popupLayer: props.popupLayer + 1 });
        }}
      >
        <div>
          {words.signByOwnerAddressToRegister[state.language]}
        </div>
        <div>
          <img className='size2x2' src={iconQr} alt=''/>
        </div>
      </button>
    </div>
  }


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter">
        <div className='flexColumn alignItemsFlexStart borderKOM marginSide1 marginTop1 padding0p5'>
          {/* asset */}
          <div className='margin1'>
            { item.asset }
          </div>
          {/* creater */}
          <TextArea2 fieldName='creatorInformationCreater' keys={['creatorInformation', 'creater']} face={words.creater[state.language]}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          {/* createrText */}
          <TextArea2 fieldName='creatorInformationCreaterText' keys={['creatorInformation', 'createrText']} face={words.createrText[state.language]}
            boxClass='box4 margin1' textAreaClass='textArea1'
          />
          {/* monacottoAddressMain */}
          <TextArea2 fieldName='creatorInformationMonacottoAddressMain' keys={['creatorInformation', 'monacottoAddressMain']}
            face={words.monacottoAddressMain[state.language]} boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          {/* createrLink */}
          <TextArea2 fieldName='creatorInformationCreaterLink0Title' keys={['creatorInformation', 'createrLink', 0, 'title']} face={words.createrLinkTitle[state.language] + 1}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink0Url' keys={['creatorInformation', 'createrLink', 0, 'url']} face={words.createrLinkUrl[state.language] + 1}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink1Title' keys={['creatorInformation', 'createrLink', 1, 'title']} face={words.createrLinkTitle[state.language] + 2}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink1Url' keys={['creatorInformation', 'createrLink', 1, 'url']} face={words.createrLinkUrl[state.language] + 2}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink2Title' keys={['creatorInformation', 'createrLink', 2, 'title']} face={words.createrLinkTitle[state.language] + 3}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          <TextArea2 fieldName='creatorInformationCreaterLink2Url' keys={['creatorInformation', 'createrLink', 2, 'url']} face={words.createrLinkUrl[state.language] + 3}
            boxClass='box4 height4 margin1 ' textAreaClass='textArea1 height70PC'
          />
          {/* register button */}
          { registerButton }
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsFlexStart widthMax padding1">
        {/* asset */}
        <div className=''>
          { item.asset }
        </div>
        {/* creater */}
        <TextArea2 fieldName='creatorInformationCreater' keys={['creatorInformation', 'creater']} face={words.creater[state.language]}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        {/* createrText */}
        <TextArea2 fieldName='creatorInformationCreaterText' keys={['creatorInformation', 'createrText']} face={words.createrText[state.language]}
          outerClass='widthMax' boxClass='box4 width96PC marginTop1 ' textAreaClass='textArea1 '
        />
        {/* monacottoAddressMain */}
        <TextArea2 fieldName='creatorInformationMonacottoAddressMain' keys={['creatorInformation', 'monacottoAddressMain']}
          face={words.monacottoAddressMain[state.language]} outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        {/* createrLink */}
        <TextArea2 fieldName='creatorInformationCreaterLink0Title' keys={['creatorInformation', 'createrLink', 0, 'title']} face={words.createrLinkTitle[state.language] + 1}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink0Url' keys={['creatorInformation', 'createrLink', 0, 'url']} face={words.createrLinkUrl[state.language] + 1}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink1Title' keys={['creatorInformation', 'createrLink', 1, 'title']} face={words.createrLinkTitle[state.language] + 2}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink1Url' keys={['creatorInformation', 'createrLink', 1, 'url']} face={words.createrLinkUrl[state.language] + 2}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink2Title' keys={['creatorInformation', 'createrLink', 2, 'title']} face={words.createrLinkTitle[state.language] + 3}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        <TextArea2 fieldName='creatorInformationCreaterLink2Url' keys={['creatorInformation', 'createrLink', 2, 'url']} face={words.createrLinkUrl[state.language] + 3}
          outerClass='widthMax' boxClass='box4 width96PC height4 marginTop1 ' textAreaClass='textArea1 height70PC'
        />
        {/* register button */}
        { registerButton }
      </div>
    </div>
  );
}

// ITEM DETAIL MORE
function ItemDetailMore(props) {
  const { state } = useGlobalStateSelector(({ state }) => ({ state }));
  const item = state.popup[props.popupLayer].body;

  let asset_longname;

  if (state.assetInfo[item.asset] !== undefined) {
    asset_longname = state.assetInfo[item.asset].asset_longname;
  }
  else {
    asset_longname = null;
  }

  let addressOwner;

  if (state.assetInfo[item.asset] !== undefined) {
    addressOwner = state.assetInfo[item.asset].owner;
  }
  else {
    addressOwner = null;
  }

  let supply;

  if (state.assetInfo[item.asset] !== undefined) {
    supply = state.assetInfo[item.asset].supply;
  }
  else {
    supply = null;
  }

  let lockState;

  if (state.assetInfo[item.asset] !== undefined) {
    if (state.assetInfo[item.asset].locked) {
      lockState = 'locked';
    }
    else {
      lockState = 'unlocked';
    }
  }
  else {
    lockState = 'blank';
  }

  let vendable;

  if (state.assetInfo[item.asset] !== undefined) {
    if (state.assetInfo[item.asset].vendable) {
      vendable = 'ok';
    }
    else {
      vendable = 'ng';
    }
  }
  else {
    vendable = 'blank';
  }

  let listed;

  if (state.assetInfo[item.asset] !== undefined) {
    if (state.assetInfo[item.asset].listed) {
      listed = 'ok';
    }
    else {
      listed = 'ng';
    }
  }
  else {
    listed = 'blank';
  }

  let reassignable;

  if (state.assetInfo[item.asset] !== undefined) {
    if (state.assetInfo[item.asset].reassignable) {
      reassignable = 'ok';
    }
    else {
      reassignable = 'ng';
    }
  }
  else {
    reassignable = 'blank';
  }

  let divisible;

  if (state.assetInfo[item.asset] !== undefined) {
    if (state.assetInfo[item.asset].divisible) {
      divisible = 'ok';
    }
    else {
      divisible = 'ng';
    }
  }
  else {
    divisible = 'blank';
  }


  return (
    <div className=''>
      {/* PC */}
      <div className="flexColumn visibleMiddleOrMore">
        <div className='flexColumn boxDetail'>
          <div>
            {words.asset[state.language]}
          </div>
          <div className='paddingLeft1'>
            {item.asset}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.asset_longname[state.language]}
          </div>
          <div className='paddingLeft1'>
            {asset_longname}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.addressOwner[state.language]}
          </div>
          <div className='paddingLeft1'>
            {addressOwner}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.issueLockStatus[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[lockState][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.dispenser[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[vendable][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.dex[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[listed][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.divisibleSend[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[divisible][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.reassign[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[reassignable][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetail'>
          <div>
            {words.totalSupply[state.language]}
          </div>
          <div className='paddingLeft1'>
            {supply}
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn alignItemsCenter widthMax visibleSmallOrLess">
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.asset[state.language]}
          </div>
          <div className='paddingLeft1'>
            {item.asset}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.asset_longname[state.language]}
          </div>
          <div className='paddingLeft1'>
            {asset_longname}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.addressOwner[state.language]}
          </div>
          <div className='paddingLeft1 breakAll'>
            {addressOwner}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.issueLockStatus[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[lockState][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.dispenser[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[vendable][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.dex[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[listed][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.divisibleSend[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[divisible][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.reassign[state.language]}
          </div>
          <div className='paddingLeft1'>
            {words[reassignable][state.language]}
          </div>
        </div>
        <div className='flexColumn boxDetailSmallScreen'>
          <div>
            {words.totalSupply[state.language]}
          </div>
          <div className='paddingLeft1'>
            {supply}
          </div>
        </div>
      </div>
    </div>
  );
}

// SEND MONA POPUP
function SendMonaPopup(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const popupLayer = props.popupLayer;

  // タイトル

  const title =
  <div className=''>
    MONA
  </div>;

  // 送信量

  const amountSection =
  <div className='flexRow justifyContentFlexStart'>
    <TextLine3 fieldName='sendMonaAmount' keys={['sendMona', 'amount']} face={words.amountToSend[state.language]} type='setStateMultiLayersFloat' tooltip='right' />
  </div>;

  // 送信元アドレス

  const addressFromSection =
  <div className='flexRow justifyContentFlexStart'>
    <TextLine3 fieldName='sendMonaAddressFrom' keys={['sendMona', 'addressFrom']} face={words.addressFrom[state.language]} tooltip='right' />
    <SelectSessionButton popupLayer={popupLayer} loginEnabled={true} />
    {/*
      <button className={'button1 ' + indicateSessions({ session: state.session })}
        onClick={ () => {
          const popup = {
            type: 'selectSessionPopup',
            body: {
              keysArray: [['sendMona', 'addressFrom']],
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
        }}
      >
        <img className='size2x2' src={iconLoginList} alt='' />
      </button>
    */}
  </div>;

  // QR読み取りボタン

  let qrButton;

  if (state.device.hasCamera) {
    qrButton =
    <button className='button1'
      onClick={ () => {
        const callback = (addressTo) => {
          dispatch({ type: 'setStateMultiLayers', keys: ['sendMona', 'addressTo'], value: addressTo });
        };

        handleClickScanQr(state, dispatch, callback, { callbackType: 'simpelCallback', popupLayer: popupLayer + 1 });
      }}
    >
      <img className='size2x2' src={iconQr} alt='' />
    </button>;
  }
  else {
    qrButton = 
    <button className='dummyPadButton1 ' disabled={true} >
    </button>;
  }

  // 送信先セクション

  const addressToSection =
  <div className='flexRow justifyContentFlexStart'>
    <TextLine3 fieldName='sendMonaAddressTo' keys={['sendMona', 'addressTo']} face={words.addressTo[state.language]} tooltip='right' />
    { qrButton }
  </div>

  // 送信ボタン

  const commitButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
    onClick={ async () => {
      // 入力チェック

      if (state.sendMona.amount.value === undefined || state.sendMona.amount.value === null || state.sendMona.amount.value === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.amountToSendIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendMona.addressFrom === undefined || state.sendMona.addressFrom === null || state.sendMona.addressFrom === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressFromIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendMona.addressTo === undefined || state.sendMona.addressTo === null || state.sendMona.addressTo === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressToIsRequired[state.language] });
        return { status: 'rejected' };
      }

      const amountMonaDecimal = new decimal(state.sendMona.amount.value);
      const amountWatanabe = decimalAdjust( 'floor',  amountMonaDecimal.times(100000000).toNumber(), 0 ); 
      const actionItemsMultiSources = addSendsToTheCartMona(state, dispatch, state.sendMona.addressFrom, state.sendMona.addressTo, amountWatanabe);

      for (const addressFrom of Object.keys(actionItemsMultiSources)) {
        ACTION_ITEM: for (const actionItem of actionItemsMultiSources[addressFrom]) {
          actionItem.status = 'unprocessed';
        }
      }

      const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

      dispatch({ type: 'setState', key: 'accessing', value: true });

      const actionItemsMultiSourcesSigned = await buildMonaTransactions(
        state, dispatch, keyPairs, actionItemsMultiSources,
        {
          provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
          transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
        }
      );

      devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

      dispatch({ type: 'setState', key: 'accessing', value: false });

      handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, 'mona');
    }}
  >
    <div>
      {words.send[state.language]}
    </div>
    <img className='size2x2' src={iconSign} alt='' />
  </button>;

  // まとめて送信ボタン

  const addToTheCartButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
    onClick={ () => {
      // 入力チェック

      if (state.sendMona.amount.value === undefined || state.sendMona.amount.value === null || state.sendMona.amount.value === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.amountToSendIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendMona.addressFrom === undefined || state.sendMona.addressFrom === null || state.sendMona.addressFrom === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressFromIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendMona.addressTo === undefined || state.sendMona.addressTo === null || state.sendMona.addressTo === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressToIsRequired[state.language] });
        return { status: 'rejected' };
      }

      const amountMonaDecimal = new decimal(state.sendMona.amount.value);
      const amountWatanabe = decimalAdjust( 'floor',  amountMonaDecimal.times(100000000).toNumber(), 0 ); 

      addSendsToTheCartMona(state, dispatch, state.sendMona.addressFrom, state.sendMona.addressTo, amountWatanabe);

      dispatch({ type: 'setNotification', key: 'notification', value: words.addedYourCart[state.language] });
    }}
  >
    <div>
      {words.sendAllAtOnce[state.language]}
    </div>
    <img className='size2x2' src={iconSign} alt='' />
  </button>;


  return (
    <div>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsFlexStart '>
        { title }
        { amountSection }
        { addressFromSection }
        { addressToSection }
        { commitButton }
        { addToTheCartButton }
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsCenter ">
        <div className='flexColumn alignItemsFlexStart '>
          { title }
          { amountSection }
          { addressFromSection }
          { addressToSection }
          <div className='flexColumn alignItemsCenter widthMax' >
            { commitButton }
            { addToTheCartButton }
          </div>
        </div>
      </div>
    </div>
  );
}

// SEND XMP POPUP
function SendXmpPopup(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const popupLayer = props.popupLayer;

  // タイトル

  const title =
  <div className=''>
    XMP
  </div>;

  // 送信量

  const amountSection =
  <div className='flexRow justifyContentFlexStart'>
    <TextLine3 fieldName='sendXmpAmount' keys={['sendXmp', 'amount']} face={words.amountToSend[state.language]} type='setStateMultiLayersFloat' tooltip='right' />
  </div>;

  // 送信元アドレス

  const addressFromSection =
  <div className='flexRow justifyContentFlexStart'>
    <TextLine3 fieldName='sendXmpAddressFrom' keys={['sendXmp', 'addressFrom']} face={words.addressFrom[state.language]} tooltip='right' />
    <SelectSessionButton popupLayer={popupLayer} loginEnabled={true} />
    {/*
      <button className={'button1 ' + indicateSessions({ session: state.session })}
        onClick={ () => {
          const popup = {
            type: 'selectSessionPopup',
            body: {
              keysArray: [['sendXmp', 'addressFrom']],
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
        }}
      >
        <img className='size2x2' src={iconLoginList} alt='' />
      </button>
    */}
  </div>;

  // QR読み取りボタン

  let qrButton;

  if (state.device.hasCamera) {
    qrButton =
    <button className='button1'
      onClick={ () => {
        const callback = (addressTo) => {
          dispatch({ type: 'setStateMultiLayers', keys: ['sendXmp', 'addressTo'], value: addressTo });
        };

        handleClickScanQr(state, dispatch, callback, { callbackType: 'simpelCallback', popupLayer: popupLayer + 1 });
      }}
    >
      <img className='size2x2' src={iconQr} alt='' />
    </button>;
  }
  else {
    qrButton = 
    <button className='dummyPadButton1 ' disabled={true} >
    </button>;
  }

  // 送信先セクション

  const addressToSection =
  <div className='flexRow justifyContentFlexStart'>
    <TextLine3 fieldName='sendXmpAddressTo' keys={['sendXmp', 'addressTo']} face={words.addressTo[state.language]} tooltip='right' />
    { qrButton }
  </div>;

  // 送信ボタン

  const commitButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTopBottom0p5 ' tabindex='0'
    onClick={ async () => {
      // 入力チェック

      if (state.sendXmp.amount.value === undefined || state.sendXmp.amount.value === null || state.sendXmp.amount.value === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.amountToSendIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendXmp.addressFrom === undefined || state.sendXmp.addressFrom === null || state.sendXmp.addressFrom === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressFromIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendXmp.addressTo === undefined || state.sendXmp.addressTo === null || state.sendXmp.addressTo === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressToIsRequired[state.language] });
        return { status: 'rejected' };
      }

      const actionItemsMultiSources = addTokensToTheCartMonaparty(state, dispatch, state.sendXmp.addressFrom, state.sendXmp.addressTo, 'XMP', new decimal(state.sendXmp.amount.value).times(100000000).toNumber());
      const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

      for (const addressFrom of Object.keys(actionItemsMultiSources)) {
        ACTION_ITEM: for (const actionItem of actionItemsMultiSources[addressFrom]) {
          actionItem.status = 'unprocessed';
        }
      }

      const actionItemsMultiSourcesSigned = await buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSources);
      devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

      handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, 'monaparty');
    }}
  >
    <div>
      {words.send[state.language]}
    </div>
    <img className='size2x2' src={iconSend} alt='' />
  </button>;

  // まとめて送信ボタン

  const addToTheCartButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTopBottom0p5 ' tabindex='0'
    onClick={ () => {
      // 入力チェック

      if (state.sendXmp.amount.value === undefined || state.sendXmp.amount.value === null || state.sendXmp.amount.value === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.amountToSendIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendXmp.addressFrom === undefined || state.sendXmp.addressFrom === null || state.sendXmp.addressFrom === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressFromIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendXmp.addressTo === undefined || state.sendXmp.addressTo === null || state.sendXmp.addressTo === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressToIsRequired[state.language] });
        return { status: 'rejected' };
      }

      addTokensToTheCartMonaparty(state, dispatch, state.sendXmp.addressFrom, state.sendXmp.addressTo, 'XMP', new decimal(state.sendXmp.amount.value).times(100000000).toNumber());

      dispatch({ type: 'setNotification', key: 'notification', value: words.addedYourCart[state.language] });
    }}
  >
    <div>
      {words.sendAllAtOnce[state.language]}
    </div>
    <img className='size2x2' src={iconSend} alt='' />
  </button>;

  return (
    <div>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsFlexStart '>
        { title }
        { amountSection }
        { addressFromSection }
        { addressToSection }
        { commitButton }
        { addToTheCartButton }
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsCenter ">
        <div className='flexColumn alignItemsFlexStart '>
          { title }
          { amountSection }
          { addressFromSection }
          { addressToSection }
          <div className='flexColumn alignItemsCenter widthMax' >
            { commitButton }
            { addToTheCartButton }
          </div>
        </div>
      </div>
    </div>
  );
}

// SEND TOKEN POPUP
function SendTokenPopup(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const popupLayer = props.popupLayer;
  const asset = state.popup[popupLayer].body.asset;

  // useEffect( () => {
  //   dispatch({ type: 'setStateMultiLayers', keys: ['sendToken', 'asset'], value: asset });
  // }, []);


  // // アセット名

  // const assetSection =
  // <div className='marginTopBottom0p5'>
  //   <TextLine3 fieldName='sendTokenAsset' keys={['sendToken', 'asset']} face={words.tokenName[state.language]} />
  // </div>;

  // 送信量

  const amountSection =
  <div className='marginTopBottom0p5'>
    <TextLine3 fieldName='sendTokenAmount' keys={['sendToken', 'amount']} face={words.amountToSend[state.language]} type='setStateMultiLayersFloat' tooltip='right' />
  </div>;


  // 送信元アドレス

  const addressFromSection =
  <div className='flexRow justifyContentFlexStart marginTopBottom0p5'>
    <TextLine3 fieldName='sendTokenAddressFrom' keys={['sendToken', 'addressFrom']} face={words.addressFrom[state.language]} tooltip='right' />
    <SelectSessionButton popupLayer={popupLayer} loginEnabled={true} />
    {/*
      <button className={'button1 ' + indicateSessions({ session: state.session })}
        onClick={ () => {
          const popup = {
            type: 'selectSessionPopup',
            body: {
              keysArray: [['sendToken', 'addressFrom']],
            },
          };

          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer + 1], value: popup });
        }}
      >
        <img className='size2x2' src={iconLoginList} alt='' />
      </button>
    */}
  </div>;

  // QR読み取りボタン

  let qrButton;

  if (state.device.hasCamera) {
    qrButton =
    <button className='button1'
      onClick={ () => {
        const callback = (addressTo) => {
          dispatch({ type: 'setStateMultiLayers', keys: ['sendToken', 'addressTo'], value: addressTo });
        };

        handleClickScanQr(state, dispatch, callback, { callbackType: 'simpelCallback', popupLayer: popupLayer + 1 });
      }}
    >
      <img className='size2x2' src={iconQr} alt='' />
    </button>;
  }
  else {
    qrButton = 
    <button className='dummyPadButton1 ' disabled={true} >
    </button>;
  }

  // 送信先セクション

  const addressToSection =
  <div className='flexRow justifyContentFlexStart marginTopBottom0p5'>
    <TextLine3 fieldName='sendTokenAddressTo' keys={['sendToken', 'addressTo']} face={words.addressTo[state.language]} tooltip='right' />
    { qrButton }
  </div>;

  // 送信ボタン

  const commitButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTopBottom0p5 ' tabindex='0'
    onClick={ async () => {
      // 入力チェック

      if (state.sendToken.amount.value === undefined || state.sendToken.amount.value === null || state.sendToken.amount.value === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.amountToSendIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendToken.addressFrom === undefined || state.sendToken.addressFrom === null || state.sendToken.addressFrom === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressFromIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendToken.addressTo === undefined || state.sendToken.addressTo === null || state.sendToken.addressTo === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressToIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendToken.asset === undefined || state.sendToken.asset === null || state.sendToken.asset === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.tokenNameIsRequired[state.language] });
        return { status: 'rejected' };
      }

      let quantity;

      if (state.assetInfo[asset] !== undefined) {
        if (state.assetInfo[asset].divisible === true) {
          quantity = new decimal(state.sendToken.amount.value).times(100000000).toNumber();
        }
        else {
          quantity = state.sendToken.amount.value;
        }
      }
      else {
        return;
      }

      const actionItemsMultiSources = addTokensToTheCartMonaparty(state, dispatch, state.sendToken.addressFrom, state.sendToken.addressTo, state.sendToken.asset, quantity);
      const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

      for (const addressFrom of Object.keys(actionItemsMultiSources)) {
        ACTION_ITEM: for (const actionItem of actionItemsMultiSources[addressFrom]) {
          actionItem.status = 'unprocessed';
        }
      }

      const actionItemsMultiSourcesSigned = await buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSources);
      devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

      handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, 'monaparty');
    }}
  >
    <div>
      {words.send[state.language]}
    </div>
    <img className='size2x2' src={iconSend} alt='' />
  </button>;

  // まとめて送信ボタン

  const addToTheCartButton =
  <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter marginTopBottom0p5 ' tabindex='0'
    onClick={ () => {
      // 入力チェック

      if (state.sendToken.amount.value === undefined || state.sendToken.amount.value === null || state.sendToken.amount.value === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.amountToSendIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendToken.addressFrom === undefined || state.sendToken.addressFrom === null || state.sendToken.addressFrom === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressFromIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendToken.addressTo === undefined || state.sendToken.addressTo === null || state.sendToken.addressTo === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.addressToIsRequired[state.language] });
        return { status: 'rejected' };
      }

      if (state.sendToken.asset === undefined || state.sendToken.asset === null || state.sendToken.asset === '') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.tokenNameIsRequired[state.language] });
        return { status: 'rejected' };
      }

      let quantity;

      if (state.assetInfo[asset] !== undefined) {
        if (state.assetInfo[asset].divisible === true) {
          quantity = new decimal(state.sendToken.amount.value).times(100000000).toNumber();
        }
        else {
          quantity = state.sendToken.amount.value;
        }
      }
      else {
        return;
      }

      addTokensToTheCartMonaparty(state, dispatch, state.sendToken.addressFrom, state.sendToken.addressTo, state.sendToken.asset, quantity);

      dispatch({ type: 'setNotification', key: 'notification', value: words.addedYourCart[state.language] });
    }}
  >
    <div>
      {words.sendAllAtOnce[state.language]}
    </div>
    <img className='size2x2' src={iconSend} alt='' />
  </button>


  return (
    <div>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsFlexStart '>
        {/* assetSection */}
        { amountSection }
        { addressFromSection }
        { addressToSection }
        { commitButton }
        { addToTheCartButton }
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsCenter ">
        <div className='flexColumn alignItemsFlexStart '>
          {/* assetSection */}
          { amountSection }
          { addressFromSection }
          { addressToSection }
          <div className='flexColumn alignItemsCenter widthMax' >
            { commitButton }
            { addToTheCartButton }
          </div>
        </div>
      </div>
    </div>
  );
}
// EDIT ASSET INFO POPUP
function EditAssetInfoPopup(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const popupLayer = props.popupLayer;
  const body = state.popup[popupLayer].body;
  const cardImageUrl = body.cardImageUrl;
  const cardImageUrlSP = body.cardImageUrlSP;
  const isAMonacard = body.isAMonacard;

  const editModeOption = [
    { value: 'editMonacard', label: words.editMonacard[state.language] },
    { value: 'additionalIssuance', label: words.additionalIssuance[state.language] },
    { value: 'lockIssuance', label: words.lockIssuance[state.language] },
    { value: 'transferOwnership', label: words.transferOwnership[state.language] },
    { value: 'editAdvancedToken', label: words.editAdvancedToken[state.language] },
  ];

  const editModeDropdown =
  <select className="custom-dropdown" value={state.editAssetInfo.editMode}
    onChange={ event => {
      dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'editMode'], value: event.target.value });
    }}
  >
    {
      editModeOption.map( option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))
    }
  </select>

  const dispatchDescription = (key, value) => {
    let description;

    try {
      description = JSON.parse(state.editAssetInfo.description);
    }
    catch {
      description = {
        monacard: {
            name: state.editAssetInfo.monacardName,
            owner: state.editAssetInfo.monacardIssuerName,
            desc: state.editAssetInfo.monacardDescription,
            tag: state.editAssetInfo.monacardTag,
            cid: state.editAssetInfo.cid,
            ver: '2',
        }
      };
    }

    description.monacard[key] = value;

    dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'description'], value: JSON.stringify(description) });
  };

  const getExtraFunctions = (key) => {
    return [
      {
        function: dispatchDescription,
        arguments: [ key ],
        targetValue: true,
      }
    ];
  };

  // 画像セクション

  let image;
  let imageSp;

  if (state.editAssetInfo.imagesNew.monacardUrl !== undefined && state.editAssetInfo.imagesNew.monacardUrl !== null) {
    image = <img className='monacardImageAbsolute' src={state.editAssetInfo.imagesNew.monacardUrl} alt='' />;
    imageSp = <img className='monacardImageAbsolute' src={state.editAssetInfo.imagesNew.monacardUrl} alt='' />;
  }
  else if (isAMonacard) {
    image = <img className='monacardImageAbsolute' src={cardImageUrl} alt='' />
    imageSp = <img className='monacardImageAbsolute' src={cardImageUrlSP} alt='' />
  }

  const onDropAccepted = useCallback((acceptedFiles) => {
    devLog('acceptedFiles', acceptedFiles);
    dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'imagesNew', 'monacard'], value: acceptedFiles[0] });
    const dataUrl = URL.createObjectURL(acceptedFiles[0]);
    devLog('dataUrl', dataUrl);
    dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'imagesNew', 'monacardUrl'], value: dataUrl });
  }, []);

  const maxFiles = 1;
  const accept = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/gif': ['.gif'],
  };

  // eslint-disable-next-line no-unused-vars
  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({ onDropAccepted, maxFiles, accept });

  const dropZoneStyle = {
    width: '272px',
    height: '388px',
    border: "1px dotted #888",
  };

  let imageSection;

  if (state.editAssetInfo.editMode === 'editMonacard' || state.editAssetInfo.editMode === 'editAdvancedToken') {
    imageSection =
    <div className='relative margin1 '>
        <div {...getRootProps()} style={dropZoneStyle} >
          <input {...getInputProps} style={{ display: 'none' }} />
          <div className='padding0p5'>
            { words.monacardImageSpecifications[state.language] }<br/>
          </div>
          <div className='padding0p5'>
            { words.dragAndDrop[state.language] }<br/>
          </div>
        </div>
        { image }
    </div>;
  }

  const inputImageFile = useRef(null);

  let imageSectionSP;

  if (state.editAssetInfo.editMode === 'editMonacard' || state.editAssetInfo.editMode === 'editAdvancedToken') {
    imageSectionSP =
    <div>
      <input ref={inputImageFile} className='invisible' type='file' accept='image/png, .png, image/jpeg, .jpg, .jpeg, image/gif, .gif' 
        onChange={ (e) => {
          devLog('acceptedFiles', JSON.stringify(e.currentTarget.files[0].name));
          dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'imagesNew', 'monacard'], value: e.currentTarget.files[0] });
          const dataUrl = URL.createObjectURL(e.currentTarget.files[0]);
          devLog('dataUrl', dataUrl);
          dispatch({ type: 'setStateMultiLayers', keys: ['editAssetInfo', 'imagesNew', 'monacardUrl'], value: dataUrl });
        }}
      />
      <button className='monacardImageContainer flexColumn justifyContentFlexStart margin1 ' onClick={ () => { inputImageFile.current.click(); } }>
        <div className='padding0p5 textLeft'>
          { words.monacardImageSpecifications[state.language] }<br/>
        </div>
        <div className='padding0p5 textLeft'>
          { words.tap[state.language] }<br/>
        </div>
        { imageSp }
      </button>
    </div>;
  }

  // モナカード更新セクション

  let editMonacardSection;

  if (state.editAssetInfo.editMode === 'editMonacard' || state.editAssetInfo.editMode === 'editAdvancedToken') {
    editMonacardSection =
    <div className='flexColumn alignItemsCenter ' >
      {/*
        <div className='relative margin1 '>
            <div {...getRootProps()} style={dropZoneStyle} >
              <input {...getInputProps} style={{ display: 'none' }} />
              <div className='padding0p5'>
                {/ words.mainImageWithDescription[state.language] /}<br/>
                {words.dragAndDrop[state.language]}<br/>
              </div>
            </div>
            { image }
        </div>
      */}
      <TextLine3 fieldName='editAssetInfoMonacardName' keys={['editAssetInfo', 'monacardName']} face={words.monacardName[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('name')} />
      <TextLine3 fieldName='editAssetInfoMonacardIssuerName' keys={['editAssetInfo', 'monacardIssuerName']} face={words.issuerName[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('owner')} />
      <TextLine3 fieldName='editAssetInfoMonacardDescription' keys={['editAssetInfo', 'monacardDescription']} face={words.monacardDescription[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('desc')} />
      <TextLine3 fieldName='editAssetInfoMonacardTag' keys={['editAssetInfo', 'monacardTag']} face={words.monacardTag[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('tag')} />
    </div>;
  }

  // モナカード更新ボタン

  let editMonacardButton;

  if (state.editAssetInfo.editMode === 'editMonacard') {
    editMonacardButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        handleClickEditAssetInfo(state, dispatch, popupLayer, state.editAssetInfo.editMode);
      }}
    >
      <div>
        {words.editMonacard[state.language]}
      </div>
      <img className='size2x2' src={iconSign} alt='' />
    </button>;
  }

  // 高度なトークン更新セクション

  let advancedSection;

  if (state.editAssetInfo.editMode === 'editAdvancedToken') {
    advancedSection =
    <div className='flexColumn alignItemsCenter ' >
      <TextArea2 fieldName='editAssetInfoDescription' keys={['editAssetInfo', 'description']} face='description'
        outerClass='box1Width' boxClass='box4 width96PC marginTop1 ' textAreaClass='textArea1'
      />
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ async () => {
          handleClickEditAssetInfo(state, dispatch, popupLayer, state.editAssetInfo.editMode);
        }}
      >
        <div>
          {words.editAdvancedToken[state.language]}
        </div>
        <img className='size2x2' src={iconSign} alt='' />
      </button>
    </div>;
  }

  // 追加発行セクション

  let additonalIssuanceSection;

  if (state.editAssetInfo.editMode === 'additionalIssuance') {
    additonalIssuanceSection =
    <div className='flexColumn alignItemsCenter ' >
      <div className='marginTopBottom0p5 ' >
        { words.currentSupply[state.language] }
      </div>
      <div className='marginTopBottom0p5' >
        { quantityForDisplay(state, { asset: state.editAssetInfo.asset }, state.editAssetInfo.supply) }
      </div>
      <TextLine3 fieldName='editAssetInfoAmount' keys={['editAssetInfo', 'amount']} face={words.amountToBeIssued[state.language]} type='setStateMultiLayersFloat' tooltip={true} />
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ async () => {
          handleClickAdditionalIssuance(state, dispatch, popupLayer);
        }}
      >
        <div>
          {words.additionalIssuance[state.language]}
        </div>
        <img className='size2x2' src={iconSign} alt='' />
      </button>
    </div>;
  }

  // 新規発行ロックセクション

  let lockIssuanceSection;

  if (state.editAssetInfo.editMode === 'lockIssuance') {
    lockIssuanceSection =
    <div className='flexColumn alignItemsCenter ' >
      <div>
        { words.cautionAboutLock[state.language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ async () => {
          handleClickLockIssuance(state, dispatch, popupLayer);
        }}
      >
        <div>
          {words.lockIssuance[state.language]}
        </div>
        <img className='size2x2' src={iconSign} alt='' />
      </button>
    </div>
  }

  // オーナー移転セクション

  let transferOwnershipSection;

  if (state.editAssetInfo.editMode === 'transferOwnership') {
    transferOwnershipSection =
    <div className='flexColumn alignItemsCenter ' >
      <div>
        <TextLine3 fieldName='editAssetInfoNewOwner' keys={['editAssetInfo', 'addressNewOwner']} face={words.addressNewOwner[state.language]} tooltip='right' />
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ async () => {
          handleClickTransferOwnership(state, dispatch, popupLayer);
        }}
      >
        <div>
          {words.transferOwnership[state.language]}
        </div>
        <img className='size2x2' src={iconSign} alt='' />
      </button>
    </div>;
  }


  return (
    <div>
      {/* PC */}
      <div className='visibleMiddleOrMore flexColumn alignItemsCenter '>
        { editModeDropdown }
        { imageSection }
        { editMonacardSection }
        { editMonacardButton }
        { additonalIssuanceSection }
        { lockIssuanceSection }
        { transferOwnershipSection }
        { advancedSection }
        {/* commitButton */}
        {/* addToTheCartButton */}
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsCenter ">
        { editModeDropdown }
        { imageSectionSP }
        { editMonacardSection }
        { editMonacardButton }
        { additonalIssuanceSection }
        { lockIssuanceSection }
        { transferOwnershipSection }
        { advancedSection }
          {/* commitButton */}
          {/* addToTheCartButton */}
      </div>
    </div>
  );
}

// CART MONA POPUP
function CartMonaPopup(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const popupLayer = props.popupLayer;


  return (
    <div className='flexColumn alignItemsCenter'>
      <div className='flexRow justifyContentCenter ' >
        {
          Object.keys(state.cartMona).map( addressFrom => {
            const actionItems = state.cartMona[addressFrom];
            return (
              <div className='flexColumn borderMonacotto margin0p5 ' >
                <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
                  <div className='margin0p5 ' >
                    from
                  </div>
                  <button className='backgroundColorTransparent borderNone margin0p5 '
                    onClick={ (event) => {
                      const actionItemsMultiSources = state.cartMona;
                      delete actionItemsMultiSources[addressFrom];
                      dispatch({ type: 'setState', key: 'cartMona', value: actionItemsMultiSources });

                      event.stopPropagation();
                    }}
                  >
                    <div className='font2 ' >
                      ×
                    </div>
                  </button>
                </div>
                <div className='margin0p5 breakAll' >
                  { addressFrom }
                </div>
                <div className='' >
                  { actionItems.map( (dummy, index) => <ActionItemMona addressFrom={addressFrom} index={index} /> ) }
                </div>
              </div>
            );
          })
        }
      </div>
      {/* commit button */}
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter margin0p5 ' tabindex='0'
        onClick={ async　() => {
          const actionItemsMultiSources = state.cartMona;

          for (const addressFrom of Object.keys(actionItemsMultiSources)) {
            ACTION_ITEM: for (const actionItem of actionItemsMultiSources[addressFrom]) {
              actionItem.status = 'unprocessed';
            }
          }

          const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

          dispatch({ type: 'setState', key: 'accessing', value: true });

          const actionItemsMultiSourcesSigned = await buildMonaTransactions(
            state, dispatch, keyPairs, actionItemsMultiSources,
            {
              provisionalTransactionFee: state.config.clientParameters.provisionalTransactionFee,
              transactionFeeUpperBound: state.config.clientParameters.transactionFeeUpperBound,
            }
          );

          devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

          dispatch({ type: 'setState', key: 'accessing', value: false });

          handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, 'mona');
        }}
      >
        <div>
          {words.send[state.language]}
        </div>
        <img className='size2x2' src={iconSign} alt='' />
      </button>
    </div>
  );
}

// ACTION ITEM MONA
function ActionItemMona(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const addressFrom = props.addressFrom;
  const index = props.index;
  const actionItems = state.cartMona[addressFrom];
  const actionItem = state.cartMona[addressFrom]?.[index];
  let actionItemBox;

  if (actionItem.action === 'send') {
    actionItemBox =
    <div className='flexColumn borderMonacottoPale padding0p5 margin0p5' >
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
        { words[actionItem.action][state.language] }
        <button className='backgroundColorTransparent borderNone '
          onClick={ (event) => {
            actionItems.splice(index, 1);
            // dispatch({ type: 'setStateMultiLayers', keys: ['cartMona', addressFrom], value: actionItems });
            const cartMona = state.cartMona;
            cleanUpObject(cartMona)
            dispatch({ type: 'setState', key: 'cartMona', value: cartMona});

            event.stopPropagation();
          }}
        >
          <div className='font2 ' >
            ×
          </div>
        </button>
      </div>
      <div className='flexColumn ' >
        {
          (actionItem?.recipients || []).map( (recipient, indexRecipient) => {
            return (
              <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5 ' >
                <div className='breakAll' >
                  { recipient.addressTo }
                </div>
                <div className='flexRow justifyContentFlexEnd alignItemsCenter ' >
                  <div className='marginLeft0p5 ' >
                    { new decimal(recipient.amountWatanabe).div(100000000).toNumber() }
                  </div>
                  <div className='marginLeft0p5 ' >
                    { 'MONA' }
                  </div>
                  <button className='backgroundColorTransparent borderNone '
                    onClick={ (event) => {
                      actionItem.recipients.splice(indexRecipient, 1);
                      // dispatch({ type: 'setStateMultiLayers', keys: ['cartMona', addressFrom, index, 'recipients'], value: actionItem.recipients });
                      const cartMona= state.cartMona;
                      cleanUpObject(cartMona)

                      if (actionItem.recipients === undefined) {
                        state.cartMona[addressFrom]?.splice(index, 1);
                      }

                      cleanUpObject(cartMona)
                      dispatch({ type: 'setState', key: 'cartMona', value: cartMona});

                      event.stopPropagation();
                    }}
                  >
                    <div className='font2 ' >
                      ×
                    </div>
                  </button>
                </div>
              </div>
            );
          })
        }
      </div>
    </div>;
  }

  return actionItemBox;
}

// ACTION ITEMS MULTI SOURCE MONA VIEW
function ActionItemsMultiSourceMonaView(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const actionItemsMultiSources = props.actionItemsMultiSources;

  // メッセージ

  let message;

  const success = Object.keys(actionItemsMultiSources).some( addressFrom =>
      actionItemsMultiSources[addressFrom].some( actionItem =>
        actionItem.statusDetail === 'signed'
      )
  )

  const fail = Object.keys(actionItemsMultiSources).some( addressFrom =>
      actionItemsMultiSources[addressFrom].some( actionItem =>
        actionItem.status === 'failed'
      )
  )

  const unprocessed = Object.keys(actionItemsMultiSources).reduce( (acc, cur) =>
    acc + actionItemsMultiSources[cur].filter( actionItem =>
      actionItem.status === 'unprocessed'
    ).length,
    0
  )

  if (success && fail) {
    message = words.doYouWantToProceedAlreadyFailedWillNot[state.language];
  }
  else if (success) {
    message = words.doYouWantToProceed[state.language];
  }
  else { // fail
    if (unprocessed >= 1) {
      message = words.failedToBuildTransactionOkOrCancel[state.language];
    }
    else {
      message = words.failedToBuildTransaction[state.language];
    }
  }


  return (
    <div>
      <div className='margin1 preWrap'>
        { message }
      </div>
      <div className='flexRow justifyContentCenter ' >
        {
          Object.keys(actionItemsMultiSources).map( addressFrom => {
            const actionItems = actionItemsMultiSources[addressFrom];

            if (actionItems.filter( actionItem => actionItem.statusDetail === 'signed' || actionItem.status === 'failed' ).length === 0) {
              return null;
            }

            return (
              <div className='flexColumn borderMonacotto margin0p5 ' >
                <div className='flexRow justifyContentFlexStart alignItemsCenter ' >
                  <div className='margin0p5 ' >
                    from
                  </div>
                </div>
                <div className='margin0p5 breakAll ' >
                  { addressFrom }
                </div>
                <div className='flexColumn alignItemsCenter padding0p5 ' >
                  {
                    actionItems
                    // .filter( actionItem => actionItem.statusDetail === 'signed' )
                    .map( actionItem => <ActionItemMonaView actionItem={actionItem} displayType='confirmation' /> )
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}

// COMMIT MONA TRANSACTION CONFIRMATION POPUP
function CommitMonaTransactionConfirmationPopup(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const popupLayer = props.popupLayer;
  const body = state.popup[popupLayer]?.body ?? {};

  return (
    <ConfirmationPopupContent
      message={<ActionItemsMultiSourceMonaView actionItemsMultiSources={body.actionItemsMultiSourcesSigned ?? {}} />}
      buttonFaceOk={body.buttonFaceOk}
      buttonFaceCancel={body.buttonFaceCancel}
      callbackOk={body.callbackOk}
      callbackCancel={body.callbackCancel}
    />
  );
}

// ACTION ITEM MONA VIEW
function ActionItemMonaView(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const actionItem = props.actionItem;
  const displayType = props.displayType;
  let actionItemBox;
  
  if (actionItem.status === 'unprocessed') {
    return null;
  }

  // if (actionItem.action === 'send' || actionItem.action === 'issue') {
    let status;
    let statusDetail;
    let addressSource;

    if (displayType === 'confirmation') {
      if (actionItem.status === 'unprocessed' || actionItem.statusDetail === 'broadcasted') {
        return null;
      }

      if (actionItem.status === 'failed') {
        status =
        <div className='' >
          { words[actionItem.status][state.language] }
        </div>;

        statusDetail =
        <div className='' >
          { actionItem.statusDetail }
        </div>;
      }
    }
    else { // history
      if (actionItem.status === 'succeeded' && actionItem.statusDetail !== 'broadcasted') {
        status =
        <div className='' >
          { words.canceled[state.language] }
        </div>;
      }
      else {
        status =
        <div className='' >
          { words[actionItem.status][state.language] }
        </div>;
      }

      statusDetail =
      <div className='' >
        { actionItem.statusDetail }
      </div>;

      if (actionItem.action === 'send') {
        addressSource =
        <div className='breakAll' >
          { 'from: ' +  actionItem.addressFrom }
        </div>;
      }
      else if (actionItem.action === 'issue') {
        addressSource =
        <div className='breakAll' >
          { 'owner: ' +  actionItem.addressIssuer }
        </div>;
      }
      else if (actionItem.action === 'editMonacard' || actionItem.action === 'additionalIssuance' || actionItem.action === 'lockIssuance' || actionItem.action === 'editAdvancedToken') {
        addressSource =
        <div className='breakAll' >
          { 'owner: ' +  actionItem.addressOwner }
        </div>;
      }
      else if (actionItem.action === 'transferOwnership') {
        addressSource =
        <div className='breakAll' >
          { 'current owner: ' +  actionItem.addressOwner }
        </div>;
      }
    }

    let subView;

    if (actionItem.transactionType === 'sendMona') {
      subView = <ActionItemMonaSubView actionItem={actionItem} />;
    }
    else if (actionItem.transactionType === 'sendToken') {
      subView = <ActionItemMonapartySubView actionItem={actionItem} />;
    }
    else if (actionItem.transactionType === 'monaparty' && actionItem.action === 'issue') {
      subView = <ActionItemIssuanceSubView actionItem={actionItem} />;
    }
    else if (actionItem.transactionType === 'monaparty' && actionItem.action === 'editMonacard') {
      subView = <ActionItemEditMonacardSubView actionItem={actionItem} />;
    }
    else if (actionItem.transactionType === 'monaparty' && actionItem.action === 'additionalIssuance') {
      subView = <ActionItemAdditionalIssuanceSubView actionItem={actionItem} />;
    }
    else if (actionItem.transactionType === 'monaparty' && actionItem.action === 'lockIssuance') {
      subView = <ActionItemLockIssuanceSubView actionItem={actionItem} />;
    }
    else if (actionItem.transactionType === 'monaparty' && actionItem.action === 'transferOwnership') {
      subView = <ActionItemTransferOwnershipSubView actionItem={actionItem} />;
    }
    else if (actionItem.transactionType === 'monaparty' && actionItem.action === 'editAdvancedToken') {
      subView = <ActionItemEditAdvancedTokenSubView actionItem={actionItem} />;
    }

    let transactionFee;

    if (actionItem.transactionFee !== undefined) {
      transactionFee =
      <div className='flexColumn alignItemsFlexStart ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.transactionFee[state.language] }
        </div>
        <div className='' >
          { new decimal(actionItem.transactionFee).div(100000000).toNumber() + ' MONA' }
        </div>
      </div>;
    }

    let expenseExcludedTransactionFee;

    if ( (actionItem.transactionType === 'sendToken' || actionItem.transactionType === 'monaparty') && actionItem.outValueExcludeChange !== undefined) {
      expenseExcludedTransactionFee =
      <div className='flexColumn alignItemsFlexStart ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.expenseExcludedTransactionFee[state.language] }
        </div>
        <div className='' >
          { new decimal(actionItem.outValueExcludeChange).div(100000000).toNumber() + ' MONA' }
        </div>
      </div>;
    }

    actionItemBox =
    <div className='flexColumn widthMax borderMonacottoPale padding0p5 ' >
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
        <div className='' >
          { words[actionItem.action][state.language] }
        </div>
        <div className='flexRow justifyContentFlexStart alignItemsCenter widthMin0 ' >
          { status }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexStart marginTop1 ' >
        { statusDetail }
      </div>
      <div className='flexColumn alignItemsFlexStart marginTop1 ' >
        { addressSource }
      </div>
      <div className='flexColumn marginTopBottom1 ' >
        { subView }
      </div>
      <div className='flexRow justifyContentFlexStart alignItemsCenter ' >
        { transactionFee }
      </div>
      <div className='flexRow justifyContentFlexStart alignItemsCenter marginTop0p5 ' >
        { expenseExcludedTransactionFee }
      </div>
    </div>;
  // }

  return actionItemBox;
}

// ACTION ITEM MONA SUB VIEW
function ActionItemMonaSubView(props) {
  const actionItem = props.actionItem;
  let actionItemBox;

  if (actionItem.action === 'send') {
    actionItemBox = actionItem.recipients.map( recipient => {
      return (
        <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5 ' >
          <div className='breakAll' >
            { recipient.addressTo }
          </div>
          <div className='flexRow justifyContentFlexEnd alignItemsCenter ' >
            <div className='marginLeft0p5 ' >
              { new decimal(recipient.amountWatanabe).div(100000000).toNumber() }
            </div>
            <div className='marginLeft0p5 ' >
              { 'MONA' }
            </div>
          </div>
        </div>
      );
    })
  }

  return actionItemBox;
}

// ACTION ITEM MONAPARTY SUB VIEW
function ActionItemMonapartySubView(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const actionItem = props.actionItem;
  let actionItemBox;

  if (actionItem.action === 'send') {
    actionItemBox = Object.keys(actionItem.recipients).map( addressTo => {
      return (
        <div className='flexColumn alignItemsFlexEnd borderMonacottoPale padding0p5 margin0p5 ' >
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
            <div className='breakAll' >
              { addressTo }
            </div>
          </div>
          <div className='flexColumn ' >
            {
              Object.keys(actionItem.recipients[addressTo]).map( asset => {
                return (
                  <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5' >
                    <AssetNameBox asset={asset} />
                    <div className='marginLeft0p5 ' >
                      { quantityForDisplay(state, { asset }, actionItem.recipients[addressTo][asset].quantity) }
                    </div>
                  </div>
                );
              })
            }
          </div>
        </div>
      );
    })
  }

  return actionItemBox;
}

// ACTION ITEM ISSUANCE SUB VIEW
function ActionItemIssuanceSubView(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const actionItem = props.actionItem;
  let actionItemBox;

  let tokenIssuanceFee;

  if (actionItem.assetType === 'tokenNameSpecified') {
    tokenIssuanceFee = 50;
  }
  else if (actionItem.assetType === 'subAsset') {
    tokenIssuanceFee = 25;
  }
  else {
    tokenIssuanceFee = 0;
  }

  if (actionItem.action === 'issue') {
    actionItemBox =
    <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5 ' >
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.tokenName[state.language] }
        </div>
        <div className='' >
          { actionItem.assetCommon }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.amountToBeIssued[state.language] }
        </div>
        <div className='' >
          { quantityForDisplay(state, actionItem) }
        </div>
      </div>
      <div className='marginBottom0p5 ' >
        <MonacardSection description={actionItem.description} />
      </div>
      <div className='flexColumn alignItemsFlexStart box4 box1Width flexWrapNoWrap padding0p5 marginBottom0p5 ' >
        <div className='marginBottom0p5 ' >
          { 'description' }
        </div>
        <div className='scrollY breakAll ' >
          { actionItem.description }
        </div>
      </div>
      <div className='' >
        { actionItem.divisible ? words.divisible[state.language] : words.notDivisible[state.language] }
      </div>
      <div className='' >
        { actionItem.listed ? words.listed[state.language] : words.notListed[state.language] }
      </div>
      <div className='' >
        { actionItem.vendable ? words.vendable[state.language] : words.notVendable[state.language] }
      </div>
      <div className='' >
        { actionItem.reassignable ? words.reassignable[state.language] : words.notReassignable[state.language] }
      </div>
      <div className='flexColumn alignItemsFlexStart widthMax marginTop0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.tokenIssuanceFee[state.language] }
        </div>
        <div className='' >
          { tokenIssuanceFee + ' XMP' }
        </div>
      </div>
    </div>;
  }

  return actionItemBox;
}

// ACTION ITEM EDIT MONACARD SUB VIEW
function ActionItemEditMonacardSubView(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const actionItem = props.actionItem;
  let actionItemBox;

  if (actionItem.action === 'editMonacard') {
    actionItemBox =
    <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5 ' >
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.tokenName[state.language] }
        </div>
        <AssetNameBox asset={actionItem.asset} />
      </div>
      <div className='marginBottom0p5 ' >
        <MonacardSection description={actionItem.description} />
      </div>
      <div className='flexColumn alignItemsFlexStart box4 box1Width flexWrapNoWrap padding0p5 marginBottom0p5 ' >
        <div className='marginBottom0p5 ' >
          { 'description' }
        </div>
        <div className='scrollY breakAll ' >
          { actionItem.description }
        </div>
      </div>
      <div className='' >
        { actionItem.divisible ? words.divisible[state.language] : words.notDivisible[state.language] }
      </div>
      <div className='' >
        { actionItem.listed ? words.listed[state.language] : words.notListed[state.language] }
      </div>
      <div className='' >
        { actionItem.vendable ? words.vendable[state.language] : words.notVendable[state.language] }
      </div>
      <div className='' >
        { actionItem.reassignable ? words.reassignable[state.language] : words.notReassignable[state.language] }
      </div>
    </div>;
  }

  return actionItemBox;
}

// ACTION ITEM ADDITIONAL ISSUANCE SUB VIEW
function ActionItemAdditionalIssuanceSubView(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const actionItem = props.actionItem;
  let actionItemBox;

  actionItemBox =
  <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5 ' >
    <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
      <div className='borderBottomMonacottoPale2Px ' >
        { words.tokenName[state.language] }
      </div>
      <AssetNameBox asset={actionItem.asset} />
    </div>
    <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
      <div className='borderBottomMonacottoPale2Px ' >
        { words.amountToBeIssued[state.language] }
      </div>
      <div className='' >
        { quantityForDisplay(state, actionItem) }
      </div>
    </div>
  </div>;

  return actionItemBox;
}

// ACTION ITEM LOCK ISSUANCE SUB VIEW
function ActionItemLockIssuanceSubView(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const actionItem = props.actionItem;
  let actionItemBox;

  actionItemBox =
  <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5 ' >
    <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
      <div className='borderBottomMonacottoPale2Px ' >
        { words.tokenName[state.language] }
      </div>
      <AssetNameBox asset={actionItem.asset} />
    </div>
  </div>;


  return actionItemBox;
}

// ACTION ITEM TRANSFER OWNERSHIP SUB VIEW
function ActionItemTransferOwnershipSubView(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const actionItem = props.actionItem;
  let actionItemBox;

  actionItemBox =
  <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5 ' >
    <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
      <div className='borderBottomMonacottoPale2Px ' >
        { words.tokenName[state.language] }
      </div>
      <AssetNameBox asset={actionItem.asset} />
    </div>
    <div className='flexColumn alignItemsFlexEnd ' >
      <div className='borderBottomMonacottoPale2Px ' >
        { words.addressNewOwner[state.language] }
      </div>
      <div className='breakAll' >
        { actionItem.addressNewOwner }
      </div>
    </div>
  </div>;


  return actionItemBox;
}

// ACTION ITEM EDIT ADVANCED TOKEN SUB VIEW
function ActionItemEditAdvancedTokenSubView(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const actionItem = props.actionItem;
  let actionItemBox;

  actionItemBox =
  <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5 ' >
    <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
      <div className='borderBottomMonacottoPale2Px ' >
        { words.tokenName[state.language] }
      </div>
      <AssetNameBox asset={actionItem.asset} />
    </div>
    <div className='marginBottom0p5 ' >
      <MonacardSection description={actionItem.description} />
    </div>
    <div className='flexColumn alignItemsFlexStart box4 box1Width flexWrapNoWrap padding0p5 marginBottom0p5 ' >
      <div className='marginBottom0p5 ' >
        { 'description' }
      </div>
      <div className='scrollY breakAll ' >
        { actionItem.description }
      </div>
    </div>
    <div className='' >
      { actionItem.divisible ? words.divisible[state.language] : words.notDivisible[state.language] }
    </div>
    <div className='' >
      { actionItem.listed ? words.listed[state.language] : words.notListed[state.language] }
    </div>
    <div className='' >
      { actionItem.vendable ? words.vendable[state.language] : words.notVendable[state.language] }
    </div>
    <div className='' >
      { actionItem.reassignable ? words.reassignable[state.language] : words.notReassignable[state.language] }
    </div>
  </div>;


  return actionItemBox;
}

// ASSET NAME BOX
function AssetNameBox(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const asset = props.asset;

  let assetBox;

  if (state.assetInfo[asset]?.asset_longname) {
    assetBox =
    <div className='flexColumn alignItemsFlexEnd' >
      <div className='' >
        { state.assetInfo[asset].asset_longname }
      </div>
      <div className='' >
        { `[${asset}]` }
      </div>
    </div>
  }
  else {
    assetBox =
    <div className='' >
      <div className='' >
        { asset }
      </div>
    </div>
  }

  return assetBox;
}

// CART MONAPARTY POPUP
function CartMonapartyPopup(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const popupLayer = props.popupLayer;


  return (
    <div className='flexColumn alignItemsCenter '>
      <div className='flexRow justifyContentCenter ' >
        {
          Object.keys(state.cartMonaparty).map( addressSource => {
            const actionItems = state.cartMonaparty[addressSource];
            return (
              <div className='flexColumn borderMonacotto margin0p5' >
                <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
                  <div className='margin0p5 ' >
                    from
                  </div>
                  <button className='backgroundColorTransparent borderNone '
                    onClick={ (event) => {
                      const actionItemsMultiSources = state.cartMonaparty;
                      delete actionItemsMultiSources[addressSource];
                      dispatch({ type: 'setState', key: 'cartMonaparty', value: actionItemsMultiSources });

                      event.stopPropagation();
                    }}
                  >
                    <div className='font2 ' >
                      ×
                    </div>
                  </button>
                </div>
                <div className='margin0p5 breakAll' >
                  { addressSource }
                </div>
                <div className='' >
                  {
                    actionItems.map( (actionItem, index) => {
                      if (actionItem.action === 'send') {
                        return <ActionItemMonaparty addressFrom={addressSource} index={index} />;
                      }
                      else if (actionItem.action === 'issue') {
                        return <ActionItemMonapartyIssue addressIssuer={addressSource} index={index} />;
                      }
                      else if (actionItem.action === 'editMonacard') {
                        return <ActionItemMonapartyEditMonacard addressIssuer={addressSource} index={index} />;
                      }
                      else if (actionItem.action === 'additionalIssuance') {
                        return <ActionItemMonapartyAdditionalIssuance addressIssuer={addressSource} index={index} />;
                      }
                      else if (actionItem.action === 'lockIssuance') {
                        return <ActionItemMonapartyLockIssuance addressOwner={addressSource} index={index} />;
                      }
                      else if (actionItem.action === 'transferOwnership') {
                        return <ActionItemMonapartyTransferOwnership addressIssuer={addressSource} index={index} />;
                      }
                      else if (actionItem.action === 'editAdvancedToken') {
                        return <ActionItemMonapartyEditAdvancedToken addressIssuer={addressSource} index={index} />;
                      }
                      else {
                        return null;
                      }
                    })
                  }
                </div>
              </div>
            );
          })
        }
      </div>
      {/* commit button */}
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter margin0p5 ' tabindex='0'
        onClick={ async () => {
          const actionItemsMultiSources = state.cartMonaparty;
          const keyPairs = getValidKeyPairs({ dispatch, keyPairs: state.keyPairs });

          for (const addressSource of Object.keys(actionItemsMultiSources)) {
            ACTION_ITEM: for (const actionItem of actionItemsMultiSources[addressSource]) {
              actionItem.status = 'unprocessed';
            }
          }

          const actionItemsMultiSourcesSigned = await buildMonapartyTransactions(state, dispatch, keyPairs, actionItemsMultiSources);
          devLog('actionItemsMultiSourcesSigned', JSON.stringify(actionItemsMultiSourcesSigned));

          handleClickCommitMonaTransaction(state, dispatch, popupLayer, actionItemsMultiSourcesSigned, 'monaparty');
        }}
      >
        <div>
          {words.send[state.language]}
        </div>
        <img className='size2x2' src={iconSign} alt='' />
      </button>
    </div>
  );
}

// ACTION ITEM MONAPARTY
function ActionItemMonaparty(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const addressFrom = props.addressFrom;
  const index = props.index;
  const actionItems = state.cartMonaparty[addressFrom];
  const actionItem = state.cartMonaparty[addressFrom]?.[index];
  let actionItemBox;

  if (actionItem.action === 'send') {
    actionItemBox =
    <div className='flexColumn borderMonacottoPale padding0p5 margin0p5 ' >
      <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
        { words[actionItem.action][state.language] }
        <button className='backgroundColorTransparent borderNone '
          onClick={ (event) => {
            actionItems.splice(index, 1);
            // dispatch({ type: 'setStateMultiLayers', keys: ['cartMonaparty', addressFrom], value: actionItems });
            const cartMonaparty = state.cartMonaparty;
            cleanUpObject(cartMonaparty)
            dispatch({ type: 'setState', key: 'cartMonaparty', value: cartMonaparty });

            event.stopPropagation();
          }}
        >
          <div className='font2 ' >
            ×
          </div>
        </button>
      </div>
      <div className='flexColumn ' >
        {
          Object.keys(actionItem.recipients || {}).map( addressTo => {
            return (
              <div className='flexColumn alignItemsFlexEnd borderMonacottoPale padding0p5 margin0p5 ' >
                <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
                  <div className='breakAll' >
                    { addressTo }
                  </div>
                  <button className='backgroundColorTransparent borderNone '
                    onClick={ (event) => {
                      delete actionItem.recipients[addressTo];
                      // dispatch({ type: 'setStateMultiLayers', keys: ['cartMonaparty', addressFrom, index, 'recipients'], value: actionItem.recipients });
                      const cartMonaparty = state.cartMonaparty;
                      cleanUpObject(cartMonaparty)

                      if (actionItem.recipients === undefined) {
                        state.cartMonaparty[addressFrom]?.splice(index, 1);
                      }

                      cleanUpObject(cartMonaparty)
                      dispatch({ type: 'setState', key: 'cartMonaparty', value: cartMonaparty });

                      event.stopPropagation();
                    }}
                  >
                    <div className='font2 ' >
                      ×
                    </div>
                  </button>
                </div>
                <div className='flexColumn ' >
                  {
                    Object.keys(actionItem.recipients[addressTo]).map( asset => {
                      return (
                        <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5' >
                          <AssetNameBox asset={asset} />
                          <div className='flexRow justifyContentFlexEnd alignItemsCenter ' >
                            <div className='marginLeft0p5 ' >
                              { quantityForDisplay(state, { asset }, actionItem.recipients[addressTo][asset].quantity) }
                            </div>
                            <button className='backgroundColorTransparent borderNone '
                              onClick={ (event) => {
                                delete actionItem.recipients[addressTo][asset];
                                // dispatch({ type: 'setStateMultiLayers', keys: ['cartMonaparty', addressFrom, index, 'recipients', addressTo], value: actionItem.recipients[addressTo] });
                                const cartMonaparty = state.cartMonaparty;
                                cleanUpObject(cartMonaparty)

                                if (actionItem.recipients === undefined) {
                                  state.cartMonaparty[addressFrom]?.splice(index, 1);
                                }

                                cleanUpObject(cartMonaparty)
                                dispatch({ type: 'setState', key: 'cartMonaparty', value: cartMonaparty });

                                event.stopPropagation();
                              }}
                            >
                              <div className='font2 ' >
                                ×
                              </div>
                            </button>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            );
          })
        }
      </div>
    </div>;
  }

  return actionItemBox;
}

// ACTION ITEM MONAPARTY ISSUE
function ActionItemMonapartyIssue(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const addressIssuer = props.addressIssuer;
  const index = props.index;
  const actionItems = state.cartMonaparty[addressIssuer];
  const actionItem = state.cartMonaparty[addressIssuer][index];
  let actionItemBox;

  actionItemBox =
  <div className='flexColumn borderMonacottoPale padding0p5 margin0p5 ' >
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
      { words[actionItem.action][state.language] }
      <button className='backgroundColorTransparent borderNone '
        onClick={ (event) => {
          actionItems.splice(index, 1);
          // dispatch({ type: 'setStateMultiLayers', keys: ['cartMonaparty', addressIssuer], value: actionItems });
          const cartMonaparty = state.cartMonaparty;
          cleanUpObject(cartMonaparty);
          dispatch({ type: 'setState', key: 'cartMonaparty', value: cartMonaparty });

          event.stopPropagation();
        }}
      >
        <div className='font2 ' >
          ×
        </div>
      </button>
    </div>
    <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5' >
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.tokenName[state.language] }
        </div>
        <div className='' >
          { actionItem.assetCommon }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.amountToBeIssued[state.language] }
        </div>
        <div className='' >
          { quantityForDisplay(state, actionItem) }
        </div>
      </div>
      <div className='marginBottom0p5 ' >
        <MonacardSection description={actionItem.description} />
      </div>
      <div className='flexColumn alignItemsFlexStart box4 box1Width flexWrapNoWrap padding0p5 marginBottom0p5 ' >
        <div className='marginBottom0p5 ' >
          { 'description' }
        </div>
        <div className='scrollY breakAll ' >
          { actionItem.description }
        </div>
      </div>
      <div className='' >
        { actionItem.divisible ? words.divisible[state.language] : words.notDivisible[state.language] }
      </div>
      <div className='' >
        { actionItem.listed ? words.listed[state.language] : words.notListed[state.language] }
      </div>
      <div className='' >
        { actionItem.vendable ? words.vendable[state.language] : words.notVendable[state.language] }
      </div>
      <div className='' >
        { actionItem.reassignable ? words.reassignable[state.language] : words.notReassignable[state.language] }
      </div>
    </div>
  </div>;


  return actionItemBox;
}

// ACTION ITEM MONAPARTY EDIT MONACARD
function ActionItemMonapartyEditMonacard(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const addressIssuer = props.addressIssuer;
  const index = props.index;
  const actionItems = state.cartMonaparty[addressIssuer];
  const actionItem = state.cartMonaparty[addressIssuer][index];
  let actionItemBox;

  actionItemBox =
  <div className='flexColumn borderMonacottoPale maxWidthMaxMinus1 padding0p5 margin0p5 ' >
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
      { words[actionItem.action][state.language] }
      <button className='backgroundColorTransparent borderNone '
        onClick={ (event) => {
          actionItems.splice(index, 1);
          // dispatch({ type: 'setStateMultiLayers', keys: ['cartMonaparty', addressIssuer], value: actionItems });
          const cartMonaparty = state.cartMonaparty;
          cleanUpObject(cartMonaparty);
          dispatch({ type: 'setState', key: 'cartMonaparty', value: cartMonaparty });

          event.stopPropagation();
        }}
      >
        <div className='font2 ' >
          ×
        </div>
      </button>
    </div>
    <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5' >
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.tokenName[state.language] }
        </div>
        <AssetNameBox asset={actionItem.asset} />
      </div>
      <div className='marginBottom0p5 ' >
        <MonacardSection description={actionItem.description} />
      </div>
      <div className='flexColumn alignItemsFlexStart box4 box1Width flexWrapNoWrap padding0p5 marginBottom0p5 ' >
        <div className='marginBottom0p5 ' >
          { 'description' }
        </div>
        <div className='scrollY breakAll ' >
          { actionItem.description }
        </div>
      </div>
      <div className='' >
        { actionItem.divisible ? words.divisible[state.language] : words.notDivisible[state.language] }
      </div>
      <div className='' >
        { actionItem.listed ? words.listed[state.language] : words.notListed[state.language] }
      </div>
      <div className='' >
        { actionItem.vendable ? words.vendable[state.language] : words.notVendable[state.language] }
      </div>
      <div className='' >
        { actionItem.reassignable ? words.reassignable[state.language] : words.notReassignable[state.language] }
      </div>
    </div>
  </div>;


  return actionItemBox;
}

// ACTION ITEM MONAPARTY ADDITIONAL ISSUANCE
function ActionItemMonapartyAdditionalIssuance(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const addressIssuer = props.addressIssuer;
  const index = props.index;
  const actionItems = state.cartMonaparty[addressIssuer];
  const actionItem = state.cartMonaparty[addressIssuer][index];
  let actionItemBox;

  actionItemBox =
  <div className='flexColumn borderMonacottoPale padding0p5 margin0p5 ' >
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
      { words[actionItem.action][state.language] }
      <button className='backgroundColorTransparent borderNone '
        onClick={ (event) => {
          actionItems.splice(index, 1);
          // dispatch({ type: 'setStateMultiLayers', keys: ['cartMonaparty', addressIssuer], value: actionItems });
          const cartMonaparty = state.cartMonaparty;
          cleanUpObject(cartMonaparty);
          dispatch({ type: 'setState', key: 'cartMonaparty', value: cartMonaparty });

          event.stopPropagation();
        }}
      >
        <div className='font2 ' >
          ×
        </div>
      </button>
    </div>
    <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5' >
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.tokenName[state.language] }
        </div>
        <AssetNameBox asset={actionItem.asset} />
      </div>
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.amountToBeIssued[state.language] }
        </div>
        <div className='' >
          { quantityForDisplay(state, actionItem) }
        </div>
      </div>
    </div>
  </div>;


  return actionItemBox;
}

// ACTION ITEM MONAPARTY LOCK ISSUANCE
function ActionItemMonapartyLockIssuance(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const addressOwner = props.addressOwner;
  const index = props.index;
  const actionItems = state.cartMonaparty[addressOwner];
  const actionItem = state.cartMonaparty[addressOwner][index];
  let actionItemBox;

  actionItemBox =
  <div className='flexColumn borderMonacottoPale padding0p5 margin0p5 ' >
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
      { words[actionItem.action][state.language] }
      <button className='backgroundColorTransparent borderNone '
        onClick={ (event) => {
          actionItems.splice(index, 1);
          // dispatch({ type: 'setStateMultiLayers', keys: ['cartMonaparty', addressOwner], value: actionItems });
          const cartMonaparty = state.cartMonaparty;
          cleanUpObject(cartMonaparty);
          dispatch({ type: 'setState', key: 'cartMonaparty', value: cartMonaparty });

          event.stopPropagation();
        }}
      >
        <div className='font2 ' >
          ×
        </div>
      </button>
    </div>
    <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5' >
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.tokenName[state.language] }
        </div>
        <AssetNameBox asset={actionItem.asset} />
      </div>
    </div>
  </div>;


  return actionItemBox;
}

// ACTION ITEM MONAPARTY TRANSFER OWNERSHIP
function ActionItemMonapartyTransferOwnership(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const addressIssuer = props.addressIssuer;
  const index = props.index;
  const actionItems = state.cartMonaparty[addressIssuer];
  const actionItem = state.cartMonaparty[addressIssuer][index];
  let actionItemBox;

  actionItemBox =
  <div className='flexColumn borderMonacottoPale padding0p5 margin0p5 ' >
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
      { words[actionItem.action][state.language] }
      <button className='backgroundColorTransparent borderNone '
        onClick={ (event) => {
          actionItems.splice(index, 1);
          // dispatch({ type: 'setStateMultiLayers', keys: ['cartMonaparty', addressIssuer], value: actionItems });
          const cartMonaparty = state.cartMonaparty;
          cleanUpObject(cartMonaparty);
          dispatch({ type: 'setState', key: 'cartMonaparty', value: cartMonaparty });

          event.stopPropagation();
        }}
      >
        <div className='font2 ' >
          ×
        </div>
      </button>
    </div>
    <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5' >
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.tokenName[state.language] }
        </div>
        <AssetNameBox asset={actionItem.asset} />
      </div>
      <div className='flexColumn alignItemsFlexEnd ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.addressNewOwner[state.language] }
        </div>
        <div className='breakAll' >
          { actionItem.addressNewOwner }
        </div>
      </div>
    </div>
  </div>;


  return actionItemBox;
}

// ACTION ITEM MONAPARTY EDIT ADVANCED TOKEN
function ActionItemMonapartyEditAdvancedToken(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const addressIssuer = props.addressIssuer;
  const index = props.index;
  const actionItems = state.cartMonaparty[addressIssuer];
  const actionItem = state.cartMonaparty[addressIssuer][index];
  let actionItemBox;

  actionItemBox =
  <div className='flexColumn borderMonacottoPale padding0p5 margin0p5 ' >
    <div className='flexRow justifyContentSpaceBetween alignItemsCenter ' >
      { words[actionItem.action][state.language] }
      <button className='backgroundColorTransparent borderNone '
        onClick={ (event) => {
          actionItems.splice(index, 1);
          // dispatch({ type: 'setStateMultiLayers', keys: ['cartMonaparty', addressIssuer], value: actionItems });
          const cartMonaparty = state.cartMonaparty;
          cleanUpObject(cartMonaparty);
          dispatch({ type: 'setState', key: 'cartMonaparty', value: cartMonaparty });

          event.stopPropagation();
        }}
      >
        <div className='font2 ' >
          ×
        </div>
      </button>
    </div>
    <div className='flexColumn alignItemsFlexEnd marginTopBottom0p5' >
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.tokenName[state.language] }
        </div>
        <AssetNameBox asset={actionItem.asset} />
      </div>
      <div className='marginBottom0p5 ' >
        <MonacardSection description={actionItem.description} />
      </div>
      <div className='flexColumn alignItemsFlexStart box4 box1Width flexWrapNoWrap padding0p5 marginBottom0p5 ' >
        <div className='marginBottom0p5 ' >
          { 'description' }
        </div>
        <div className='scrollY breakAll ' >
          { actionItem.description }
        </div>
      </div>
      <div className='' >
        { actionItem.divisible ? words.divisible[state.language] : words.notDivisible[state.language] }
      </div>
      <div className='' >
        { actionItem.listed ? words.listed[state.language] : words.notListed[state.language] }
      </div>
      <div className='' >
        { actionItem.vendable ? words.vendable[state.language] : words.notVendable[state.language] }
      </div>
      <div className='' >
        { actionItem.reassignable ? words.reassignable[state.language] : words.notReassignable[state.language] }
      </div>
    </div>
  </div>;


  return actionItemBox;
}

// MONACARD SECTION
function MonacardSection(props) {
  const { state } = useGlobalStateSelector(({ state }) => ({ state }));
  const description = props.description;

  let descriptionObj;

  try {
    descriptionObj = JSON.parse(description);
  }
  catch (error) {
    // 何もしない
  }

  let monacardSection;

  if (
    descriptionObj?.monacard?.name !== undefined && descriptionObj.monacard.name !== null && descriptionObj.monacard.name !== '' &&
    descriptionObj?.monacard?.owner !== undefined && descriptionObj.monacard.owner !== null && descriptionObj.monacard.owner !== '' &&
    descriptionObj?.monacard?.desc !== undefined && descriptionObj.monacard.desc !== null && descriptionObj.monacard.desc !== '' &&
    descriptionObj?.monacard?.cid !== undefined && descriptionObj.monacard.cid !== null && descriptionObj.monacard.cid !== ''
  ) {
    monacardSection =
    <div className='flexColumn alignItemsFlexEnd ' >
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.monacardName[state.language] }
        </div>
        <div className='' >
          { descriptionObj.monacard.name }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.issuerName[state.language] }
        </div>
        <div className='' >
          { descriptionObj.monacard.owner }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexEnd marginBottom0p5 ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.monacardDescription[state.language] }
        </div>
        <div className='' >
          { descriptionObj.monacard.desc }
        </div>
      </div>
      <div className='flexColumn alignItemsFlexEnd ' >
        <div className='borderBottomMonacottoPale2Px ' >
          { words.monacardTag[state.language] }
        </div>
        <div className='' >
          { descriptionObj.monacard.tag }
        </div>
      </div>
    </div>;
  }


  return monacardSection;
}

/*
// CONDITION DIVISION
function ConditionDivision(props) {
  const [state, dispatch] = useContext(GlobalState);
  const popupLayer = props.popupLayer;
  const condition = props.condition;
  const conditionKey = props.conditionKey;

  if (condition[conditionKey].length <= 0) {
    return null;
  }

  return (
    <div className='flexColumn alignItemsCenter borderMonacottoPale margin0p5'>
      <div className='flexColumn margin0p5 ' >
        { conditionKey }
      </div>
      {
        condition[conditionKey].map( value =>
          <ValueForDisplayInList popupLayer={popupLayer} conditionKey={conditionKey} value={value} />
        )
      }
    </div>
  );
}
*/

// ACTION HISTORY
function ActionHistory(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);

  const handleFetchTxids = async () => {
    const address = state.getHistoryInBlockChain?.address;
    const trimmedAddress = (address ?? '').trim();

    if (trimmedAddress === '') {
      return;
    }

    try {
      const transactionsFetched = await fetchRecentTxids(state, trimmedAddress);
      dispatch({ type: 'setStateMultiLayers', keys: ['getHistoryInBlockChain', 'transactions'], value: transactionsFetched });
    }
    catch (error) {
      devLog('fetchRecentTxids error', String(error));
    }
  };

  const transactions = state.getHistoryInBlockChain.transactions ?? [];

  const records = state.actionHistory.map( actionItem => {
    let txid;

    if (actionItem.txid !== undefined) {
      txid =
      <div className='margin0p5 '>
        { 'TXID: ' + actionItem.txid }
      </div>
    }

    return (
      <div className='widthMax '>
        {/* PC */}
        <div className='visibleMiddleOrMore boxMonacotto1 flexColumn justifyContentCenter alignItemsFlexStart padding0p5 margin0p5' >
          {/*
            <div className='margin0p5 '>
              { actionItem.statusDetail }
            </div>
          */}
          <div className='breakAll' >
            { txid }
          </div>
          <ActionItemMonaView actionItem={actionItem} displayType='history' />
        </div>
        {/* SP */}
        <div className='visibleSmallOrLess boxMonacotto1SmallScreen flexColumn justifyContentCenter alignItemsFlexStart padding0p5 ' >
          {/*
            <div className='margin0p5 '>
              { actionItem.statusDetail }
            </div>
          */}
          <div className='breakAll' >
            { txid }
          </div>
          <ActionItemMonaView actionItem={actionItem} displayType='history' />
        </div>
      </div>
    );
  });


  return (
    <div className='width98vw '>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter">
        <div className='flexRow justifyContentFlexEnd widthMax marginBottom1' >
          <div className='flexRow ' >
            <button className='button2' onClick={ () => handleClickGoTop({ navigate }) }>
              { words.back[state.language] }
            </button>
          </div>
        </div>
        <div className='flexColumn alignItemsFlexStart ' >
          { records }
        </div>
          {
            process.env.REACT_APP_ENVIRONMENT === 'dev' ? 
              <div className='flexColumn alignItemsFlexStart ' >
                <div className='flexColumn alignItemsFlexStart marginBottom0p5 ' >
                  <div className='flexRow justifyContentCenter alignItemsCenter marginTop0p5'>
                    <TextLine3 fieldName='getHistoryAddress' keys={['getHistoryInBlockChain', 'address']} face={'アドレス'} tooltip='rightLong' />
                    <button className='button1' onClick={ () => handleClickMpurse(state, dispatch, ['getHistoryInBlockChain', 'address']) }>
                      <img className='size2x2' src={iconAddress} alt='' />
                    </button>
                  </div>
                  <div className='flexRow justifyContentCenter alignItemsCenter marginTop0p5 '>
                    <div className='marginRight0p5'>
                      <TextLine3 fieldName='getHistoryPageSize' keys={['getHistoryInBlockChain', 'pageSize']} face={'pageSize'} tooltip='right' type='setStateMultiLayersFloat' adjustType='floor' adjustExp={0} />
                    </div>
                    <div className='marginRight0p5'>
                      <TextLine3 fieldName='getHistoryMaxPages' keys={['getHistoryInBlockChain', 'maxPages']} face={'maxPages'} tooltip='right' type='setStateMultiLayersFloat' adjustType='floor' adjustExp={0} />
                    </div>
                    <button className='button2 marginRight0p5 ' onClick={ handleFetchTxids }>
                      { 'Txid取得' }
                    </button>
                  </div>
                </div>
                <div className='flexColumn alignItemsFlexStart widthMax ' >
                  {
                    transactions.map( (transactionItem, index) => (
                      <div className='breakAll marginBottom0p5 ' key={ (transactionItem?.txid ?? '') + '_' + index }>
                        { `${transactionItem?.txid ?? ''} value:${transactionItem?.value ?? ''} fees:${transactionItem?.fees ?? ''} vout:${Array.isArray(transactionItem?.vout) ? transactionItem.vout.length : 0} involvement:${transactionItem?.addressInvolvement ?? ''}` }
                      </div>
                    ))
                  }
                </div>
              </div>
            : null
          }
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn widthMax ">
        <div className='flexRow justifyContentFlexEnd widthMax marginBottom1' >
          <button className='button2' onClick={ () => handleClickGoTop({ navigate }) }>
            { words.back[state.language] }
          </button>
        </div>
        { records }
      </div>
    </div>
  );
}
// ISSUANCE
function Issuance(props) {
  const state = useGlobalStateSelector( ({ state }) => state );
  const dispatch = useGlobalStateSelector( ({ dispatch }) => dispatch );
  const navigate = useGlobalStateSelector( ({ navigate }) => navigate );

  const resetParent = (addressIssuer) => {
    if ( state.ownedAssets[addressIssuer] !== undefined ) {
      if ( !state.ownedAssets[addressIssuer].map( ownedAsset => ownedAsset.asset ).includes(state.issuance.parent) ) {
        const parentDefault = state.ownedAssets[addressIssuer]
        .filter( asset => !asset.asset.startsWith('A') )
        .map( asset => {
          return { value: asset.asset, label: asset.asset };
        })[0];

        dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'parent'], value: parentDefault !== undefined ? parentDefault.value : '' });
      }
      else {
        // 何もしない。
      }
    }
    else {
      dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'parent'], value: '' });
    }
  };

  useEffect( () => {
    getAssetNames({ dispatch, clientParameters: state.config.clientParameters });
    resetParent(state.issuance.addressIssuer);
  }, []);

  const issueModeOption = [
    { value: 'issueMonacard', label: words.issueMonacard[state.language] },
    { value: 'issueAdvancedToken', label: words.issueAdvancedToken[state.language] },
  ];

  const issueModeDropdown =
  <select className="custom-dropdown" value={state.issuance.issueMode}
    onChange={ event => {
      dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'issueMode'], value: event.target.value });
    }}
  >
    {
      issueModeOption.map( option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))
    }
  </select>

  const assetTypeOption = [
    { value: 'tokenNameLeftToTheSystem', label: words.tokenNameLeftToTheSystem[state.language] },
    { value: 'tokenNameSpecified', label: words.tokenNameSpecified[state.language] },
    { value: 'subAsset', label: words.subAsset[state.language] },
  ];

  const assetTypeDropdown =
  <select className="custom-dropdown" value={state.issuance.assetType}
    onChange={ event => {
      dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'assetType'], value: event.target.value });
    }}
  >
    {
      assetTypeOption.map( option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))
    }
  </select>

  const dispatchDescription = (key, value) => {
    const description = {
      monacard: {
          name: state.issuance.monacardName,
          owner: state.issuance.monacardIssuerName,
          desc: state.issuance.monacardDescription,
          tag: state.issuance.monacardTag,
          cid: '',
          ver: '2',
      }
    };

    description.monacard[key] = value;

    dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'description'], value: JSON.stringify(description) });
  };

  const getExtraFunctions = (key) => {
    return [
      {
        function: dispatchDescription,
        arguments: [ key ],
        targetValue: true,
      }
    ];
  };

  // 画像セクション

  let image;

  if (state.issuance.imagesNew.monacardUrl !== undefined && state.issuance.imagesNew.monacardUrl !== null) {
    image = <img className='monacardImageAbsolute' src={state.issuance.imagesNew.monacardUrl} alt='' />;
  }

  const revokeMonacardBlobUrl = (url) => {
    if (typeof url === 'string' && url.startsWith('blob:')) {
      URL.revokeObjectURL(url);
    }
  };

  const onDropAccepted = useCallback((acceptedFiles) => {
    devLog('acceptedFiles', acceptedFiles);
    revokeMonacardBlobUrl(state.issuance.imagesNew.monacardUrl);
    dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'imagesNew', 'monacard'], value: acceptedFiles[0] });
    const dataUrl = URL.createObjectURL(acceptedFiles[0]);
    devLog('dataUrl', dataUrl);
    dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'imagesNew', 'monacardUrl'], value: dataUrl });
  }, [state.issuance.imagesNew.monacardUrl]);

  const maxFiles = 1;
  const accept = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/gif': ['.gif'],
  };

  // eslint-disable-next-line no-unused-vars
  const { getRootProps, getInputProps, acceptedFiles, fileRejections } = useDropzone({ onDropAccepted, maxFiles, accept });

  const dropZoneStyle = {
    width: '272px',
    height: '388px',
    border: "1px dotted #888",
  };

  const imageSection =
  <div className='relative margin1 '>
      <div {...getRootProps()} style={dropZoneStyle} >
        <input {...getInputProps} style={{ display: 'none' }} />
        <div className='padding0p5'>
          { words.monacardImageSpecifications[state.language] }<br/>
        </div>
        <div className='padding0p5'>
          { words.dragAndDrop[state.language] }<br/>
        </div>
      </div>
      { image }
  </div>;

  const inputImageFile = useRef(null);

  const imageSectionSp =
  <div>
    <input ref={inputImageFile} className='invisible' type='file' accept='image/png, .png, image/jpeg, .jpg, .jpeg, image/gif, .gif' 
      onChange={ (e) => {
        devLog('acceptedFiles', JSON.stringify(e.currentTarget.files[0].name));
        revokeMonacardBlobUrl(state.issuance.imagesNew.monacardUrl);
        dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'imagesNew', 'monacard'], value: e.currentTarget.files[0] });
        const dataUrl = URL.createObjectURL(e.currentTarget.files[0]);
        devLog('dataUrl', dataUrl);
        dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'imagesNew', 'monacardUrl'], value: dataUrl });
      }}
    />
    <button className='monacardImageContainer flexColumn justifyContentFlexStart margin1 ' onClick={ () => { inputImageFile.current.click(); } }>
      <div className='padding0p5 textLeft'>
        { words.monacardImageSpecifications[state.language] }<br/>
      </div>
      <div className='padding0p5 textLeft'>
        { words.tap[state.language] }<br/>
      </div>
      { image }
    </button>
  </div>;

  // トークン名セクション

  let assetCommonSection;
  let parentOption;

  if (state.ownedAssets[state.issuance.addressIssuer] !== undefined) {
    parentOption = state.ownedAssets[state.issuance.addressIssuer]
    .filter( asset => !asset.asset.startsWith('A') )
    .map( asset => {
      return { value: asset.asset, label: asset.asset };
    });
  }
  else {
    parentOption = [];
  }

  const parentDropdown =
  <select className="custom-dropdown" value={state.issuance.parent}
    onChange={ event => {
      dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'parent'], value: event.target.value });
    }}
  >
    {
      parentOption.map( option => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))
    }
  </select>

  if (state.issuance.assetType === 'tokenNameSpecified') {
    assetCommonSection =
    <TextLine3 fieldName='issuanceAssetCommon' keys={['issuance', 'assetCommon']} face={words.assetCommon[state.language]} tooltip={true} />;
  }
  else if (state.issuance.assetType === 'subAsset') {
    assetCommonSection =
    <div className='flexColumn alignItemsCenter ' >
      { parentDropdown }
      <TextLine3 fieldName='issuanceSubAsset' keys={['issuance', 'subAsset']} face={words.subAsset[state.language]} tooltip={true} />
    </div>;
  }

  // アドバンストセクション

  let advancedSection;

  if (state.issuance.issueMode === 'issueAdvancedToken') {
    advancedSection =
    <div className='flexColumn alignItemsCenter ' >
      <TextArea2 fieldName='issuanceDescription' keys={['issuance', 'description']} face='description'
        outerClass='box1Width' boxClass='box4 width96PC marginTop1 ' textAreaClass='textArea1'
      />
      <div className='flexColumn alignItemsFlexStart ' >
        {/*
          <button className='flexRow justifyContentCenter backgroundColorTransparent borderNone font1 marginTopBottom0p5 '
            onClick={ () => {
              dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'lock'], value: !state.issuance.lock });
            }}
          >
            <div className={'width1 height1 borderMonacottoNoRadius marginSide0p5 ' + (state.issuance.lock ? 'backgroundColorPinkPale' : 'backgroundColorTransparent')} >
            </div>
            <div className='font1 marginSide0p5' >
              { 'lock' }
            </div>
          </button>
        */}
        <button className='flexRow justifyContentCenter backgroundColorTransparent borderNone font1 marginTopBottom0p5 '
          onClick={ () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'divisible'], value: !state.issuance.divisible });
          }}
        >
          <div className={'width1 height1 borderMonacottoNoRadius marginSide0p5 ' + (state.issuance.divisible ? 'backgroundColorPinkPale' : 'backgroundColorTransparent')} >
          </div>
          <div className='font1 marginSide0p5' >
            { 'divisible' }
          </div>
        </button>
        <button className='flexRow justifyContentCenter backgroundColorTransparent borderNone font1 marginTopBottom0p5 '
          onClick={ () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'listed'], value: !state.issuance.listed });
          }}
        >
          <div className={'width1 height1 borderMonacottoNoRadius marginSide0p5 ' + (state.issuance.listed ? 'backgroundColorPinkPale' : 'backgroundColorTransparent')} >
          </div>
          <div className='font1 marginSide0p5' >
            { 'listed' }
          </div>
        </button>
        <button className='flexRow justifyContentCenter backgroundColorTransparent borderNone font1 marginTopBottom0p5 '
          onClick={ () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'vendable'], value: !state.issuance.vendable });
          }}
        >
          <div className={'width1 height1 borderMonacottoNoRadius marginSide0p5 ' + (state.issuance.vendable ? 'backgroundColorPinkPale' : 'backgroundColorTransparent')} >
          </div>
          <div className='font1 marginSide0p5' >
            { 'vendable' }
          </div>
        </button>
        <button className='flexRow justifyContentCenter backgroundColorTransparent borderNone font1 marginTopBottom0p5 '
          onClick={ () => {
            dispatch({ type: 'setStateMultiLayers', keys: ['issuance', 'reassignable'], value: !state.issuance.reassignable });
          }}
        >
          <div className={'width1 height1 borderMonacottoNoRadius marginSide0p5 ' + (state.issuance.reassignable ? 'backgroundColorPinkPale' : 'backgroundColorTransparent')} >
          </div>
          <div className='font1 marginSide0p5' >
            { 'reassignable' }
          </div>
        </button>
      </div>
    </div>;
  }

  // コミットボタン

  let commitButtonWord;

  if (state.issuance.issueMode === 'issueMonacard') {
    commitButtonWord = words.issueMonacard[state.language];
  }
  else if (state.issuance.issueMode === 'issueAdvancedToken') {
    commitButtonWord = words.issueToken[state.language];
  }

  // クリアボタン

  const issuanceDefault = {
    ...getInitialIssuanceState(),
    addressIssuer: state.issuance.addressIssuer,
  };

  const clearIssuanceButton =
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ () => {
        revokeMonacardBlobUrl(state.issuance.imagesNew.monacardUrl);
        dispatch({ type: 'setState', key: 'issuance', value: issuanceDefault });
      }}
    >
      { words.clear[state.language] }
    </button>;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore flexColumn alignItemsCenter">
        <div className='flexRow justifyContentFlexEnd widthMax marginBottom1' >
          <div className='flexRow ' >
            <button className='button2' onClick={ () => handleClickGoTop({ navigate }) }>
              { words.back[state.language] }
            </button>
          </div>
        </div>
        <div className='' >
          <FirstTransactionRitualButton />
        </div>
        <div className='marginBottom1 ' >
          { clearIssuanceButton }
        </div>
        <div className='marginBottom0p5 ' >
          { issueModeDropdown }
        </div>
        <div className='' >
          { assetTypeDropdown }
        </div>
        { imageSection }
        <TextLine3 fieldName='issuanceAddressIssuer' keys={['issuance', 'addressIssuer']} face={words.addressIssuer[state.language]} tooltip={true}
          extraFunctionOnChange={ [
            {
              function: (addressIssuer) => resetParent(addressIssuer),
              arguments: [],
              targetValue: true,
            }
          ]}
        />
        { assetCommonSection }
        <TextLine3 fieldName='issuanceAmount' keys={['issuance', 'amount']} face={words.amountToBeIssued[state.language]} type='setStateMultiLayersFloat' tooltip={true} />
        <TextLine3 fieldName='issuanceMonacardName' keys={['issuance', 'monacardName']} face={words.monacardName[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('name')} />
        <TextLine3 fieldName='issuanceMonacardIssuerName' keys={['issuance', 'monacardIssuerName']} face={words.issuerName[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('owner')} />
        <TextLine3 fieldName='issuanceMonacardDescription' keys={['issuance', 'monacardDescription']} face={words.monacardDescription[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('desc')} />
        <TextLine3 fieldName='issuanceMonacardTag' keys={['issuance', 'monacardTag']} face={words.monacardTag[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('tag')} />
        { advancedSection }
        <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
          onClick={ async () => {
            handleClickIssueAsset(state, dispatch);
          }}
        >
          <div>
            { commitButtonWord }
          </div>
          <img className='size2x2' src={iconSign} alt='' />
        </button>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsCenter">
        <div className='flexRow justifyContentFlexEnd widthMax marginBottom1' >
          <button className='button2' onClick={ () => handleClickGoTop({ navigate }) }>
            { words.back[state.language] }
          </button>
        </div>
        <div className='' >
          <FirstTransactionRitualButton />
        </div>
        <div className='marginBottom1 ' >
          { clearIssuanceButton }
        </div>
        <div className='marginBottom0p5 ' >
          { issueModeDropdown }
        </div>
        <div className='' >
          { assetTypeDropdown }
        </div>
        { imageSectionSp }
        <TextLine3 fieldName='issuanceAddressIssuer' keys={['issuance', 'addressIssuer']} face={words.addressIssuer[state.language]} tooltip={true}
          extraFunctionOnChange={ [
            {
              function: (addressIssuer) => resetParent(addressIssuer),
              arguments: [],
              targetValue: true,
            }
          ]}
        />
        { assetCommonSection }
        <TextLine3 fieldName='issuanceAmount' keys={['issuance', 'amount']} face={words.amountToBeIssued[state.language]} type='setStateMultiLayersFloat' tooltip={true} />
        <TextLine3 fieldName='issuanceMonacardName' keys={['issuance', 'monacardName']} face={words.monacardName[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('name')} />
        <TextLine3 fieldName='issuanceMonacardIssuerName' keys={['issuance', 'monacardIssuerName']} face={words.issuerName[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('owner')} />
        <TextLine3 fieldName='issuanceMonacardDescription' keys={['issuance', 'monacardDescription']} face={words.monacardDescription[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('desc')} />
        <TextLine3 fieldName='issuanceMonacardTag' keys={['issuance', 'monacardTag']} face={words.monacardTag[state.language]} tooltip={true} extraFunctionOnChange={getExtraFunctions('tag')} />
        { advancedSection }
        <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
          onClick={ async () => {
            handleClickIssueAsset(state, dispatch);
          }}
        >
          <div>
            { commitButtonWord }
          </div>
          <img className='size2x2' src={iconSign} alt='' />
        </button>
      </div>
    </div>
  );
}

// FIRST TRANSACTION RITUAL BUTTON
function FirstTransactionRitualButton(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined && popupLayer !== null ? (popupLayer + 1) : 0;

  return (
    <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
      onClick={ async () => {
        const popup = { type: 'firstTransactionRitualPopup' };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
      }}
    >
      { words.beforeIssuingForTheFirstTime[state.language] }
    </button>
  );
}

// FIRST TRANSACTION RITUAL POPUP
function FirstTransactionRitualPopup(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));
  const popupLayer = props.popupLayer;

  return (
    <div className='flexColumn alignItemsCenter '>
      <div className='marginBottom0p5 ' >
        { state.active.addressMain }
      </div>
      <div className='textCenter marginBottom1' >
        { words.ifYouAreIssuingMonacardForTheFirstTimeWithThisAddressClickTheFollowingButtonBeforeIssuingMonacardToSendATokenToYourself[state.language] } <br/>
        { words.afterSendingATokenWaitForAFewMinutesAndThenIssueMonacard[state.language] }
      </div>
      <div className='marginBottom0p5 ' >
        { words.theTokenISelectedsRandomly[state.language] }
      </div>
      <div className='marginBottom1 ' >
        { words.ifYouDoNotPerformThisRitualTheIssuanceOfAMonacardMayFail[state.language] }
      </div>
      <button className='buttonMainColor widthMin20 heightMin4 flexRow justifyContentCenter alignItemsCenter ' tabindex='0'
        onClick={ async () => {
          firstTransactionRitual(state, dispatch, popupLayer);
        }}
      >
        { words.sendToken[state.language] }
      </button>
    </div>
  );
}

export {
  ActionItemsMultiSourceMonaView,
  CommitMonaTransactionConfirmationPopup,
  BalanceMona,
  BalanceXmp,
  BalanceMonaparty,
  ItemDetail,
  ItemDetailMore,
  MonadomInfo,
  CreatorInformation,
  ActionHistory,
  Issuance,
  SendMonaPopup,
  SendXmpPopup,
  SendTokenPopup,
  EditAssetInfoPopup,
  CartMonaPopup,
  CartMonapartyPopup,
  FirstTransactionRitualPopup,
};